(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7955],{

/***/ 34631:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/demyst_meta_image.f5a4009b.png","height":640,"width":1240,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAABlBMVEUXCk0nG1ke+WECAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAEUlEQVR4nGNgQAKMjOgMMAAAAGwABa6H6+kAAAAASUVORK5CYII="});

/***/ }),

/***/ 25883:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/demyst.b13d9333.png","height":60,"width":60,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAFVBMVEUpYaAeWZw0aaViirmRrs6guNRulL/jQ5ZwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKElEQVR4nGNgQAAmJiZGEM3IzMLCDGIxsjEzsjKhMJhZIVIg1RAaAgALzABS43lQBgAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 22788:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/AUFlag.da3ac393.svg","height":24,"width":32});

/***/ }),

/***/ 29886:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/CAFlag.299716c8.svg","height":24,"width":32});

/***/ }),

/***/ 57983:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/DEFlag.f3d28de0.svg","height":24,"width":32});

/***/ }),

/***/ 95629:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/ESFlag.7e82b9db.svg","height":18,"width":24});

/***/ }),

/***/ 18250:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/FRFlag.21c1b47e.svg","height":18,"width":24});

/***/ }),

/***/ 29518:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/GlobeFlag.5a1335b1.svg","height":20,"width":28});

/***/ }),

/***/ 35686:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/HKFlag.15087683.svg","height":18,"width":24});

/***/ }),

/***/ 82183:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/IDFlag.3c865012.svg","height":24,"width":32});

/***/ }),

/***/ 20744:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/INFlag.364dfea0.svg","height":24,"width":32});

/***/ }),

/***/ 38805:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/MXFlag.b6911111.svg","height":24,"width":32});

/***/ }),

/***/ 13851:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/NAFlag.e155d3c6.svg","height":24,"width":19});

/***/ }),

/***/ 86578:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/NZFlag.a4606171.svg","height":24,"width":32});

/***/ }),

/***/ 98367:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/PFlag.3106a05f.svg","height":24,"width":32});

/***/ }),

/***/ 68882:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/SGFlag.79f62e23.svg","height":24,"width":32});

/***/ }),

/***/ 68083:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/THFlag.27dc9bf6.svg","height":18,"width":24});

/***/ }),

/***/ 57260:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/UKFlag.2bc15cf6.svg","height":24,"width":32});

/***/ }),

/***/ 77799:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/USFlag.83aeec85.svg","height":24,"width":32});

/***/ }),

/***/ 37202:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/VNFlag.fa3e6533.svg","height":18,"width":24});

/***/ }),

/***/ 92064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ footerMenu; }
/* harmony export */ });
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71571);

var footerMenu = {
    copy: "\xa9 ".concat(new Date().getFullYear(), " DemystData, Ltd."),
    social: [
        {
            type: "LinkedIn",
            url: "https://www.linkedin.com/company/demystdata"
        }
    ],
    columns: [
        {
            header: "Company",
            items: [
                {
                    name: "Contact us",
                    url: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_0__/* .linksConstants.CONTACT */ .s.CONTACT,
                    isExternal: false
                }
            ]
        },
        {
            header: "Legal",
            items: [
                {
                    name: "Privacy Policy",
                    shortName: "Privacy",
                    url: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_0__/* .linksConstants.PRIVACY */ .s.PRIVACY,
                    isExternal: false
                },
                {
                    name: "Accessibility Policy",
                    shortName: "Accessibility",
                    url: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_0__/* .linksConstants.ACCESSIBILITY */ .s.ACCESSIBILITY,
                    isExternal: false
                },
                {
                    name: "Terms and Conditions",
                    shortName: "Terms",
                    url: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_0__/* .linksConstants.TERMS */ .s.TERMS,
                    isExternal: false
                },
                {
                    name: "Cookie Policy",
                    shortName: "Cookies",
                    url: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_0__/* .linksConstants.COOKIE_POLICY */ .s.COOKIE_POLICY,
                    isExternal: false
                },
                {
                    name: "Manage Cookies",
                    hideShort: true,
                    url: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_0__/* .linksConstants.MANAGE_COOKIE */ .s.MANAGE_COOKIE,
                    isExternal: false
                },
                {
                    name: "Personal Information Request (CA)",
                    hideShort: true,
                    url: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_0__/* .linksConstants.CCPA */ .s.CCPA,
                    isExternal: false
                },
                {
                    name: "Data Subject Action Request",
                    hideShort: true,
                    url: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_0__/* .linksConstants.DSAR */ .s.DSAR,
                    isExternal: false
                }, 
            ]
        }, 
    ]
};


/***/ }),

/***/ 45911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ DemystLogo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);


function DemystLogo(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#FFFFFF" : _fill, _width = param.width, width = _width === void 0 ? 190 : _width, _height = param.height, height = _height === void 0 ? 47 : _height, className = param.className, id = param.id;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 ".concat(width, " ").concat(height),
        className: className,
        id: id,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M53.147 32.1449C59.863 32.1449 63.9043 28.2988 63.9043 21.7769C63.9043 15.255 59.8571 11.4089 53.147 11.4089H46.0146V32.1449H53.147ZM52.9358 7.76864C62.3616 7.76864 67.9456 12.9967 67.9456 21.7769C67.9456 30.5571 62.3558 35.7852 52.9358 35.7852H44.2198C42.8883 35.7852 42.0495 34.9912 42.0495 33.6563V9.89752C42.0495 8.55668 42.8824 7.76276 44.2198 7.76276H52.9358V7.76864Z",
                fill: fill
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M75.2422 23.9469H88.5861C87.8764 20.7713 85.3718 18.6777 81.9112 18.6777C78.4565 18.6777 75.9519 20.7713 75.2422 23.9469ZM92.1347 24.9114C92.1347 26.3758 91.2608 27.2108 89.8003 27.2108H75.1659C75.7525 30.6394 78.3333 32.8976 82.1282 32.8976C84.5859 32.8976 86.5097 31.9332 87.718 30.5159C88.0934 30.0983 88.5509 29.8455 89.1375 29.8455C90.1815 29.8455 90.8912 30.5571 90.8912 31.5627C90.8912 31.9391 90.7681 32.3154 90.5159 32.6507C88.6389 34.9089 85.6768 36.2909 82.1341 36.2909C75.6293 36.2909 71.3299 32.0684 71.3299 25.7935C71.3299 19.5598 75.6234 15.2962 81.923 15.2962C87.8001 15.2962 92.1406 19.4775 92.1406 24.8291V24.9114H92.1347Z",
                fill: fill
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M126.706 24.1998V34.0679C126.706 35.2794 126.037 36.0322 124.911 36.0322C123.744 36.0322 123.075 35.2794 123.075 34.0679V24.6174C123.075 20.7301 121.45 18.6777 118.365 18.6777C115.157 18.6777 113.192 21.1888 113.192 25.2878V34.0679C113.192 35.2794 112.523 36.0322 111.356 36.0322C110.271 36.0322 109.561 35.2794 109.561 34.0679V24.6174C109.561 20.7301 107.936 18.6777 104.81 18.6777C101.602 18.6777 99.6366 21.1888 99.6366 25.2878V34.0679C99.6366 35.2794 98.968 36.0322 97.8008 36.0322C96.6746 36.0322 96.0059 35.2794 96.0059 34.0679V17.5485C96.0059 16.2959 96.6746 15.5432 97.8008 15.5432C98.968 15.5432 99.6366 16.2959 99.6366 17.5485V18.0484H99.7188C101.009 16.2489 103.097 15.2903 105.637 15.2903C108.599 15.2903 110.728 16.5017 111.895 18.76H111.978C113.356 16.5429 115.731 15.2903 119.028 15.2903C124.16 15.2962 126.706 18.3836 126.706 24.1998Z",
                fill: fill
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M150.132 17.5486V34.1503C150.132 40.337 146.337 44.0596 140.126 44.0596C136.413 44.0596 133.369 43.0128 131.703 40.8369C131.492 40.5428 131.328 40.1253 131.328 39.6666C131.328 38.6609 132.037 37.9082 133.123 37.9082C133.709 37.9082 134.043 38.1199 134.46 38.5374C135.838 39.9194 137.586 40.6663 140.05 40.6663C144.091 40.6663 146.513 38.2434 146.513 34.315V32.5566H146.431C144.93 34.6031 142.513 35.7793 139.381 35.7793C133.879 35.7793 130.876 32.5154 130.876 26.4522V17.5486C130.876 16.2959 131.586 15.5432 132.712 15.5432C133.838 15.5432 134.507 16.2959 134.507 17.5486V26.0758C134.507 30.216 136.507 32.386 140.261 32.386C144.097 32.386 146.513 29.7102 146.513 25.3231V17.5486C146.513 16.2959 147.223 15.5432 148.308 15.5432C149.47 15.5432 150.132 16.2959 150.132 17.5486Z",
                fill: fill
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M163.353 23.9058C169.987 23.9881 172.322 25.8288 172.322 29.969C172.322 33.9386 169.066 36.285 163.564 36.285C159.353 36.285 156.602 35.4499 154.637 33.6092C154.303 33.274 154.098 32.8153 154.098 32.3154C154.098 31.2686 154.807 30.5571 155.769 30.5571C156.227 30.5571 156.69 30.7688 157.101 31.0981C158.561 32.3507 160.731 33.0211 163.312 33.0211C166.691 33.0211 168.691 31.8508 168.691 29.8866C168.691 28.1282 167.4 27.4225 163.019 27.3755C156.678 27.3343 154.344 25.6171 154.344 21.6887C154.344 17.8014 157.722 15.2903 163.06 15.2903C166.48 15.2903 168.855 16.0019 170.773 17.5897C171.231 18.0073 171.442 18.466 171.442 19.0129C171.442 20.142 170.732 20.8536 169.735 20.8536C169.318 20.8536 168.943 20.7301 168.65 20.4772C167.066 19.2246 165.312 18.5953 163.312 18.5953C160.057 18.5953 157.975 19.8068 157.975 21.6887C157.975 23.2824 159.183 23.8646 163.353 23.9058Z",
                fill: fill
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M189.789 32.6448C188.622 35.0677 186.246 36.285 183.114 36.285C178.445 36.285 175.606 33.3152 175.606 28.34V10.9443C175.606 9.73286 176.316 8.9801 177.442 8.9801C178.568 8.9801 179.237 9.73286 179.237 10.9443V15.796H187.161C188.287 15.796 188.956 16.4665 188.956 17.5133C188.956 18.5601 188.287 19.1834 187.161 19.1834H179.237V28.4635C179.237 31.2628 180.738 32.8976 183.284 32.8976C184.997 32.8976 186.076 32.1449 186.915 30.8099C187.208 30.3924 187.625 30.0572 188.334 30.0572C189.296 30.0572 190.006 30.7688 190.006 31.8156C190 32.1037 189.912 32.3919 189.789 32.6448Z",
                fill: fill
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M28.2657 23.4765C28.1542 25.3054 27.468 27.399 24.0543 28.4693C18.3237 30.263 15.0684 34.2326 13.8249 35.4676C12.2823 37.0025 11.0681 39.1314 10.2176 42.0659C9.16186 45.6886 8.22338 47.0059 4.92699 47.0059C2.20541 47.0059 0 44.7947 0 42.0659C0 39.3372 1.62473 37.4965 4.92699 37.126C12.7339 36.2556 18.4117 31.0746 18.4117 23.6059V23.4059C18.4117 15.9372 12.7339 10.7561 4.92699 9.88576C1.62473 9.50938 0 7.66867 0 4.93994C0 2.21121 2.20541 0 4.92699 0C8.22338 0 9.75427 1.88188 10.2704 4.93994C10.6927 7.4452 12.2823 10.0034 13.8249 11.5383C15.0684 12.7792 18.3237 16.7429 24.0543 18.5365C27.468 19.601 28.1542 21.7005 28.2657 23.5235V23.4765Z",
                fill: fill
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3.58382 28.4399H4.63373C7.27319 28.4399 9.58419 26.4463 9.74256 23.8058C9.91265 20.9418 7.64858 18.5601 4.82143 18.5601C4.82143 18.5601 3.74805 18.5307 3.44304 18.5601C2.32274 18.6659 1.49571 19.4657 1.34321 20.5654C1.13792 22.0651 1.13792 24.8703 1.34321 26.3052C1.51917 27.4696 2.3638 28.3341 3.58382 28.4399Z",
                fill: fill
            })
        ]
    });
}
DemystLogo.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    fill: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number),
    id: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    width: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)
};


/***/ }),

/***/ 32792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ DateRangePickerComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4758);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86010);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2777);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6805);
/* harmony import */ var react_click_away_listener__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55078);
/* harmony import */ var _buttons_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57);
/* harmony import */ var _config_appConfig__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84762);
/* harmony import */ var _Paper_Paper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1668);
/* harmony import */ var _utils_getFormattedDateRange__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65303);














var DateRangePickerComponent = function(param) {
    var startDate = param.startDate, endDate = param.endDate, onApply = param.onApply, disabled = param.disabled;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showDateRangePicker = ref[0], setShowDateRangePicker = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(startDate), internalStartDate = ref1[0], setInternalStartDate = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(endDate), internalEndDate = ref2[0], setInternalEndDate = ref2[1];
    var compareDates = function(dateString1, dateString2, direction) {
        var dates = [
            dateString2
        ];
        var isFirstLater = dateString1 > dateString2;
        isFirstLater ? dates.push(dateString1) : dates.unshift(dateString1);
        return dates[direction];
    };
    var openDateRangePicker = function() {
        setShowDateRangePicker(true);
    };
    var closeDateRangePicker = function(event) {
        if (event) {
            if (event.target !== event.currentTarget) {
                return;
            }
        }
        setShowDateRangePicker(false);
        if (!internalStartDate || !internalEndDate) {
            return;
        } else {
            onApply([
                internalStartDate,
                internalEndDate
            ]);
        }
    };
    var currentDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(new Date(), "yyyy-MM-dd");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "DateRangePickerComponent",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_buttons_Button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("DateRangePickerComponent__button", showDateRangePicker && "DateRangePickerComponent__button--active"),
                variant: "whiteWithShadow",
                onClick: openDateRangePicker,
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_9__/* .FiCalendar */ .vlc, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: (0,_utils_getFormattedDateRange__WEBPACK_IMPORTED_MODULE_10__/* .getFormattedDateRange */ .s)(startDate, endDate)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_9__/* .FiChevronDown */ .bTu, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .AnimatePresence */ .M_, {
                children: showDateRangePicker && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_click_away_listener__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    onClickAway: function() {
                        return closeDateRangePicker();
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .ww.div, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                        className: "DateRangePickerComponent__popupWrapper",
                        onClick: closeDateRangePicker
                    }, _config_appConfig__WEBPACK_IMPORTED_MODULE_5__/* .animatePresenceConfig */ .Rr), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paper_Paper__WEBPACK_IMPORTED_MODULE_6__/* .Paper */ .X, {
                            showBorder: false,
                            elevation: 2,
                            borderRadius: "md",
                            showArrow: true,
                            arrowPlacement: "top",
                            arrowClassName: "DateRangePickerComponent__arrow",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "DatePickerContainer",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                        htmlFor: "start",
                                        children: "Start date:"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        type: "date",
                                        id: "start",
                                        name: "trip-start",
                                        min: "2010-01-01",
                                        max: compareDates(internalEndDate, currentDate, 0),
                                        onChange: function(event) {
                                            return setInternalStartDate(event.target.value);
                                        },
                                        value: internalStartDate
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                        htmlFor: "start",
                                        children: "End date:"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                        type: "date",
                                        id: "end",
                                        name: "trip-end",
                                        min: compareDates("2010-01-01", internalStartDate, 1),
                                        max: currentDate,
                                        onChange: function(event) {
                                            return setInternalEndDate(event.target.value);
                                        },
                                        value: internalEndDate
                                    })
                                ]
                            })
                        })
                    }))
                })
            })
        ]
    });
};
DateRangePickerComponent.propTypes = {
    endDate: prop_types__WEBPACK_IMPORTED_MODULE_13__.PropTypes.string,
    maxDate: prop_types__WEBPACK_IMPORTED_MODULE_13__.PropTypes.string,
    minDate: prop_types__WEBPACK_IMPORTED_MODULE_13__.PropTypes.string,
    onApply: prop_types__WEBPACK_IMPORTED_MODULE_13__.PropTypes.func,
    startDate: prop_types__WEBPACK_IMPORTED_MODULE_13__.PropTypes.string
};


/***/ }),

/***/ 5786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86010);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2777);




var Loader = function(param) {
    var className = param.className, _fullHeight = param.fullHeight, fullHeight = _fullHeight === void 0 ? false : _fullHeight, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _withPadding = param.withPadding, withPadding = _withPadding === void 0 ? false : _withPadding;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("Loader", fullHeight && "Loader--fullHeight", fullWidth && "Loader--fullWidth", withPadding && "Loader--withPadding", className),
        role: "progressbar",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_2__/* .FiLoader */ .dAq, {})
    });
};
Loader.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.PropTypes.string,
    fullHeight: prop_types__WEBPACK_IMPORTED_MODULE_3__.PropTypes.bool,
    fullWidth: prop_types__WEBPACK_IMPORTED_MODULE_3__.PropTypes.bool,
    withPadding: prop_types__WEBPACK_IMPORTED_MODULE_3__.PropTypes.bool
};


/***/ }),

/***/ 43454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ MessageBox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86010);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2777);




var Icon = function(param) {
    var type = param.type;
    switch(type){
        case "success":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_1__/* .FiCheckCircle */ ._rq, {});
        case "info":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_1__/* .FiInfo */ .H33, {});
        case "error":
        default:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_1__/* .FiAlertTriangle */ .BJv, {});
            }
    }
};
var MessageBox = function(param) {
    var className = param.className, _type = param.type, type = _type === void 0 ? "error" : _type, _showIcon = param.showIcon, showIcon = _showIcon === void 0 ? true : _showIcon, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("MessageBox", "MessageBox__".concat(type), className),
        children: showIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                    type: type
                }),
                children
            ]
        }) : children
    });
};
MessageBox.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.PropTypes.node,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.PropTypes.string,
    type: prop_types__WEBPACK_IMPORTED_MODULE_3__.PropTypes.oneOf([
        "error",
        "info",
        "success"
    ])
};


/***/ }),

/***/ 69581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6805);
/* harmony import */ var _config_appConfig__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84762);









var Modal = function(param) {
    var open = param.open, onBackdropClick = param.onBackdropClick, backdropClassName = param.backdropClassName, motionElementClassName = param.motionElementClassName, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), renderPortalWrapper = ref[0], setRenderPortalWrapper = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), renderContent = ref1[0], setRenderContent = ref1[1];
    var modalRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (open) {
            setRenderPortalWrapper(true);
            setRenderContent(true);
            setTimeout(function() {
                var ref;
                (ref = modalRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            }, 0);
        } else {
            setRenderContent(false);
            setTimeout(function() {
                return setRenderPortalWrapper(false);
            }, 200);
        }
    }, [
        open
    ]);
    if (!renderPortalWrapper) return null;
    // TODO: Create focus trap
    return /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "Modal",
        role: "presentation",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .AnimatePresence */ .M_, {
            children: renderContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_3__/* .motion.div */ .ww.div, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("Modal__motionElement", motionElementClassName)
            }, _config_appConfig__WEBPACK_IMPORTED_MODULE_4__/* .animatePresenceConfig */ .Rr), {
                ref: modalRef,
                tabIndex: -1,
                "aria-modal": "true",
                role: "dialog",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("Modal__backdrop", backdropClassName),
                        onClick: onBackdropClick,
                        "aria-hidden": "true"
                    }),
                    children
                ]
            }), "modal")
        })
    }), document.querySelector("#__next"));
};
Modal.propTypes = {
    backdropClassName: prop_types__WEBPACK_IMPORTED_MODULE_8__.PropTypes.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_8__.PropTypes.node,
    motionElementClassName: prop_types__WEBPACK_IMPORTED_MODULE_8__.PropTypes.string,
    onBackdropClick: prop_types__WEBPACK_IMPORTED_MODULE_8__.PropTypes.func,
    open: prop_types__WEBPACK_IMPORTED_MODULE_8__.PropTypes.bool
};


/***/ }),

/***/ 1668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Paper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);





var Paper = function(param) {
    var arrowClassName = param.arrowClassName, _arrowPlacement = param.arrowPlacement, arrowPlacement = _arrowPlacement === void 0 ? "top" : _arrowPlacement, borderRadius = param.borderRadius, children = param.children, className = param.className, _elevation = param.elevation, elevation = _elevation === void 0 ? 0 : _elevation, _showArrow = param.showArrow, showArrow = _showArrow === void 0 ? false : _showArrow, _showBorder = param.showBorder, showBorder = _showBorder === void 0 ? true : _showBorder, _semanticElement = param.semanticElement, semanticElement = _semanticElement === void 0 ? "div" : _semanticElement, _focusedChartNode = param.focusedChartNode, focusedChartNode = _focusedChartNode === void 0 ? null : _focusedChartNode;
    var SemanticElementToRender = semanticElement;
    var parentChartFocused = focusedChartNode && document.activeElement.isEqualNode(focusedChartNode);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SemanticElementToRender, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("Paper", "Paper__elevation--".concat(elevation), borderRadius && "Paper__borderRadius--".concat(borderRadius), showBorder && "Paper--withBorder", className)
    }, parentChartFocused ? {
        role: "status",
        "aria-live": "assertive"
    } : {}), {
        children: [
            showArrow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("Paper__arrow", "Paper__arrow--".concat(arrowPlacement), arrowClassName)
            }),
            children
        ]
    }));
};
Paper.propTypes = {
    arrowClassName: prop_types__WEBPACK_IMPORTED_MODULE_4__.PropTypes.string,
    arrowPlacement: prop_types__WEBPACK_IMPORTED_MODULE_4__.PropTypes.oneOf([
        "top",
        "bottom",
        "left",
        "right",
        "top-right"
    ]),
    borderRadius: prop_types__WEBPACK_IMPORTED_MODULE_4__.PropTypes.oneOf([
        "xs",
        "sm",
        "md",
        "lg"
    ]),
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.PropTypes.node,
    className: prop_types__WEBPACK_IMPORTED_MODULE_4__.PropTypes.string,
    elevation: prop_types__WEBPACK_IMPORTED_MODULE_4__.PropTypes.oneOf([
        1,
        2
    ]),
    showArrow: prop_types__WEBPACK_IMPORTED_MODULE_4__.PropTypes.bool,
    showBorder: prop_types__WEBPACK_IMPORTED_MODULE_4__.PropTypes.bool
};


/***/ }),

/***/ 87990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ LinkButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var _utils_createTestId__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6282);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);









function LinkButton(_param) {
    var className = _param.className, testId = _param.testId, variant = _param.variant, size = _param.size, disabled = _param.disabled, fullWidth = _param.fullWidth, onClick = _param.onClick, _buttonProps = _param.buttonProps, buttonProps = _buttonProps === void 0 ? {} : _buttonProps, children = _param.children, href = _param.href, isExternal = _param.isExternal, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "testId",
        "variant",
        "size",
        "disabled",
        "fullWidth",
        "onClick",
        "buttonProps",
        "children",
        "href",
        "isExternal"
    ]);
    // You can't disable a link, so if you pass `disabled` prop this component just renders a button
    if (disabled) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            variant: variant,
            className: className,
            size: size,
            disabled: disabled,
            fullWidth: fullWidth,
            onClick: onClick,
            "data-test-id": testId
        }, buttonProps), {
            children: children
        }));
    }
    if (isExternal) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("Button", variant && "Button--".concat(variant), size && "Button--".concat(size), "Button--linkButton", className),
            "data-test-id": (0,_utils_createTestId__WEBPACK_IMPORTED_MODULE_7__/* .createTestId */ .z)(testId),
            onClick: onClick,
            href: href
        }, props), {
            children: children
        }));
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            href: href,
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("Button", variant && "Button--".concat(variant), size && "Button--".concat(size), "Button--linkButton", className)
        }, props), {
            "data-test-id": (0,_utils_createTestId__WEBPACK_IMPORTED_MODULE_7__/* .createTestId */ .z)(testId),
            onClick: onClick,
            children: children
        }));
    }
}
LinkButton.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().node),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    fullWidth: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),
    id: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    isExternal: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().func),
    size: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    testId: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    to: prop_types__WEBPACK_IMPORTED_MODULE_8___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_8___default().object),
        (prop_types__WEBPACK_IMPORTED_MODULE_8___default().func)
    ]),
    variant: prop_types__WEBPACK_IMPORTED_MODULE_8___default().oneOf([
        "outlined",
        "warning",
        "icon",
        "clear",
        "whiteWithShadow",
        "withShadow",
        "withBlueShadow",
        "noBorder", 
    ])
};


/***/ }),

/***/ 77721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DevTools": function() { return /* binding */ DevTools; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@wojtekmaj/react-hooks/dist/esm/useToggle.js
var useToggle = __webpack_require__(51215);
// EXTERNAL MODULE: ./node_modules/@wojtekmaj/react-hooks/dist/esm/useEventListener.js
var useEventListener = __webpack_require__(13704);
// EXTERNAL MODULE: ./src/config/appConfig.js
var appConfig = __webpack_require__(84762);
// EXTERNAL MODULE: ./src/platform/components/formComponents/index.js + 2 modules
var formComponents = __webpack_require__(10005);
// EXTERNAL MODULE: ./src/platform/components/buttons/Button.jsx
var Button = __webpack_require__(57);
// EXTERNAL MODULE: ./src/api/api.js
var api = __webpack_require__(84557);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/platform/components/Paper/Paper.jsx
var Paper = __webpack_require__(1668);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/platform/layout/DevToolsSelect.jsx





var DevToolsSelect = function(param) {
    var label = param.label, lsValueName = param.lsValueName, _trueLabel = param.trueLabel, trueLabel = _trueLabel === void 0 ? "Show" : _trueLabel, _falseLabel = param.falseLabel, falseLabel = _falseLabel === void 0 ? "Hide" : _falseLabel;
    var ref = (0,react.useState)("false"), selectValue = ref[0], setSelectValue = ref[1];
    var defaultValue = window.localStorage.getItem(lsValueName) || false;
    var onSelectChange = function(value, key) {
        localStorage.setItem(key, value);
        setSelectValue(value);
    };
    (0,react.useEffect)(function() {
        setSelectValue(defaultValue);
    }, [
        lsValueName
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formComponents/* Select */.Ph, {
        label: label,
        size: "sm",
        defaultValue: defaultValue,
        onChange: function(event) {
            return onSelectChange(event.target.value, lsValueName);
        },
        inputClassName: selectValue === "true" ? "DevTools__paper__item--true" : "DevTools__paper__item--false",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: "false",
                children: falseLabel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                value: "true",
                children: trueLabel
            })
        ]
    });
};
DevToolsSelect.propTypes = {
    falseLabel: (prop_types_default()).string,
    label: (prop_types_default()).string,
    lsValueName: (prop_types_default()).string,
    trueLabel: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./src/platform/layout/DevTools.jsx













var DevToolsComponent = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(), 2), showDevTools = ref[0], toggleShowDevTools = ref[1];
    var onDevtoolsShortcutPress = (0,react.useCallback)(function(event) {
        if (event.ctrlKey && event.key === appConfig/* appConfig.DEVTOOLS_SHORTCUT_KEY */.eG.DEVTOOLS_SHORTCUT_KEY || event.ctrlKey && event.code === "Key".concat(appConfig/* appConfig.DEVTOOLS_SHORTCUT_KEY.toUpperCase */.eG.DEVTOOLS_SHORTCUT_KEY.toUpperCase())) {
            toggleShowDevTools();
        }
    }, []);
    (0,useEventListener/* default */.Z)(document, "keypress", onDevtoolsShortcutPress);
    var onLocalDemystConsoleApiUrlChange = function(apiAddress) {
        (0,api/* setDemystConsoleApiUrl */.Eb)(apiAddress);
    };
    var onLocalBlackfinApiUrlChange = function(apiAddress) {
        (0,api/* setBlackfinApiUrl */.vG)(apiAddress);
    };
    // const onLocalVariantChange = (cookieName, variant) => {
    //   window.localStorage.setItem(cookieName, variant);
    //   document.cookie = `${cookieName}=${variant}`;
    // };
    var reloadPage = function() {
        window.location.reload(false);
    };
    if (!showDevTools) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "DevTools",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* Paper */.X, {
            className: "DevTools__paper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "DevTools__paper__table",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "DevTools__paper__column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "DevTools__paper__column__title",
                                    children: "Environment Settings"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formComponents/* Select */.Ph, {
                                    label: "Demyst Console API URL",
                                    size: "sm",
                                    defaultValue: appConfig/* appConfig.DEMYST_CONSOLE_API_URL */.eG.DEMYST_CONSOLE_API_URL,
                                    onChange: function(event) {
                                        return onLocalDemystConsoleApiUrlChange(event.target.value);
                                    },
                                    children: Object.keys(appConfig/* demystConsoleApiUrls */.Vd).map(function(envName) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: appConfig/* demystConsoleApiUrls */.Vd[envName],
                                            children: envName
                                        }, envName);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formComponents/* Select */.Ph, {
                                    label: "Blackfin API URL",
                                    size: "sm",
                                    defaultValue: appConfig/* appConfig.BLACKFIN_API_URL */.eG.BLACKFIN_API_URL,
                                    onChange: function(event) {
                                        return onLocalBlackfinApiUrlChange(event.target.value);
                                    },
                                    children: Object.keys(appConfig/* blackfinApiUrls */.t0).map(function(envName) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: appConfig/* blackfinApiUrls */.t0[envName],
                                            children: envName
                                        }, envName);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "DevTools__paper__column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "DevTools__paper__column__title",
                                    children: "Nav Pages"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Projects",
                                    lsValueName: "projects_visible"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Internal Data",
                                    lsValueName: "internal_data_visible"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Reports Monitor",
                                    lsValueName: "reports_monitor"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "New Homepage",
                                    lsValueName: "new_homepage"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Table Provider Exports",
                                    lsValueName: "table_provider_exports"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Table Provider Imports",
                                    lsValueName: "table_provider_imports"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "DevTools__paper__column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "DevTools__paper__column__title",
                                    children: "Features"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "User Tracking in Browser Console",
                                    lsValueName: "user_tracking_visible"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Checklist on Admin",
                                    lsValueName: "checklist"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Contracts on Billing",
                                    lsValueName: "contracts_on_billing_visible"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Attributes",
                                    lsValueName: "attributes"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Global Catalog Statistics",
                                    lsValueName: "global_catalog_statistics"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DevToolsSelect, {
                                    label: "Data Utilization Sans Graphs",
                                    lsValueName: "data_utilization_sans_graphs"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "DevTools__paper__actions",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            onClick: reloadPage,
                            children: "Reload"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            variant: "transparent",
                            onClick: function() {
                                return toggleShowDevTools();
                            },
                            children: "Close"
                        })
                    ]
                })
            ]
        })
    });
};
DevToolsComponent.propTypes = {};
var DevTools = dynamic_default()((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
    return runtime_default().wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                return _ctx.abrupt("return", DevToolsComponent);
            case 1:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
})), {
    ssr: false
});


/***/ }),

/***/ 91313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ generatePath; },
/* harmony export */   "L": function() { return /* binding */ matchPath; }
/* harmony export */ });
var generatePath = function() {
    var template = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return template.split("/").map(function(s) {
        if (s.startsWith(":")) {
            return params[s.slice(1)];
        }
        return s;
    }).join("/");
};
var matchPath = function() {
    var pathname = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _path = ref.path, path = _path === void 0 ? "" : _path, _exact = ref.exact, exact = _exact === void 0 ? true : _exact;
    if (exact) return pathname === path;
    else {
        if (pathname.startsWith(path)) return true;
        var splittedPath = path.split("/");
        var splittedPathname = pathname.split("/");
        var doesMatch = true;
        for(var i = 0; i < splittedPathname.length; i += 1){
            var ref1;
            if ((ref1 = splittedPath[i]) === null || ref1 === void 0 ? void 0 : ref1.startsWith(":")) {
                doesMatch = true;
            } else {
                doesMatch = splittedPath[i] === splittedPathname[i];
            }
            if (!doesMatch) break;
        }
        return doesMatch;
    }
};


/***/ }),

/***/ 75168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ PlatformHead; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _landingPage_assets_demyst_meta_image_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34631);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71571);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _context_NonceContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25455);







var createMetaTitle = function(title) {
    var displayCompany = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var companyName = "Demyst";
    if (!title) {
        return companyName;
    }
    if (displayCompany) {
        return "".concat(title, " | ").concat(companyName);
    }
    return title;
};
var trimAndClipText = function(text) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 150;
    var trimmedText = text.trim();
    if (trimmedText.length > length) {
        return "".concat(trimmedText.substr(0, length - 1), "…");
    }
    return trimmedText;
};
var PlatformHead = function(param) {
    var title = param.title, _description = param.description, description = _description === void 0 ? "" : _description, children = param.children, _displayCompanyName = param.displayCompanyName, displayCompanyName = _displayCompanyName === void 0 ? true : _displayCompanyName, _pageImageUrl = param.pageImageUrl, pageImageUrl = _pageImageUrl === void 0 ? null : _pageImageUrl, _pageImageWidth = param.pageImageWidth, pageImageWidth = _pageImageWidth === void 0 ? null : _pageImageWidth, _pageImageHeight = param.pageImageHeight, pageImageHeight = _pageImageHeight === void 0 ? null : _pageImageHeight, _canonical = param.canonical, canonical = _canonical === void 0 ? null : _canonical, _pageType = param.pageType, pageType = _pageType === void 0 ? "website" : _pageType, currentPath = param.currentPath;
    var nonce = (0,_context_NonceContext__WEBPACK_IMPORTED_MODULE_5__/* .useNonce */ .X)().nonce;
    var formattedTitle = trimAndClipText(createMetaTitle(title, displayCompanyName), 65);
    var formattedDescription = (description === null || description === void 0 ? void 0 : description.length) && trimAndClipText(description);
    var originUrl = "https://demyst.com";
    var currentUrl = originUrl + isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_4___default().sanitize(currentPath);
    var canonicalUrl = canonical !== null ? originUrl + canonical : currentUrl;
    var imageUrl = function() {
        if (pageImageUrl) return pageImageUrl;
        // turning off pre-rendered images as they aren't working as intended...
        // if (isPreRendered) return `${originUrl}${imageName}`;
        return originUrl + _landingPage_assets_demyst_meta_image_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        nonce: nonce,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: formattedTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "Demyst"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: "en_US"
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: formattedDescription
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: formattedDescription
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: formattedDescription
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: pageType
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@demystdata"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:domain",
                content: "demyst.com"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: imageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: imageUrl
            }),
            pageImageHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: pageImageHeight
            }),
            pageImageWidth && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: pageImageWidth
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                nonce: nonce,
                dangerouslySetInnerHTML: {
                    __html: "window[(function(_CP2,_RC){var _cW8T4='';for(var _LSEFSL=0;_LSEFSL<_CP2.length;_LSEFSL++){_3Kz3!=_LSEFSL;var _3Kz3=_CP2[_LSEFSL].charCodeAt();_RC>9;_3Kz3-=_RC;_3Kz3+=61;_3Kz3%=94;_3Kz3+=33;_cW8T4==_cW8T4;_cW8T4+=String.fromCharCode(_3Kz3)}return _cW8T4})(atob('XEtSdHFsZ2V2TWd7'), 2)] = 'a6f395c0d81699221108';     var zi = document.createElement('script');     (zi.type = 'text/javascript'),     (zi.async = true),     (zi.src = (function(_Nut,_cV){var _PHNl8='';for(var _qmZeLE=0;_qmZeLE<_Nut.length;_qmZeLE++){var _9810=_Nut[_qmZeLE].charCodeAt();_9810-=_cV;_9810+=61;_9810%=94;_9810+=33;_9810!=_qmZeLE;_cV>5;_PHNl8==_PHNl8;_PHNl8+=String.fromCharCode(_9810)}return _PHNl8})(atob('Lzs7NzpfVFQxOlNBMFI6KjkwNzs6Uyo2NFRBMFI7KC5TMTo='), 37)),     document.readyState === 'complete'?document.body.appendChild(zi):     window.addEventListener('load', function(){         document.body.appendChild(zi)     }); "
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                nonce: nonce,
                type: "application/ld+json",
                children: '{\n        "@context":"https://schema.org",\n        "@graph": [\n          {\n            "@type":"Organization",\n            "name":"Demyst",\n            "url":"'.concat(originUrl, '",\n            "logo":"').concat(originUrl + _landingPage_assets_demyst_meta_image_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, '",\n            "sameAs":[\n              "https://twitter.com/demystdata",\n              "https://www.linkedin.com/company/demystdata"\n            ]\n          },\n          {\n            "@type":"WebSite",\n            "@id":"').concat(originUrl, '/#website",\n            "url":"').concat(originUrl, '",\n            "name":"Demyst",\n            "inLanguage":"en-US"\n          },\n          {\n            "@type":"WebPage",\n            "@id":"').concat(currentUrl, '#webpage",\n            "url":"').concat(currentUrl, '",\n            "name":"').concat(formattedTitle, '",\n            "isPartOf":{\n              "@id":"').concat(originUrl, '/#website"\n            },\n            "inLanguage":"en-US",\n            ').concat(description && '"description":"'.concat(formattedDescription, '",'), '\n            "potentialAction":[\n              {\n                "@type":"ReadAction",\n                "target":[\n                  "').concat(currentUrl, '"\n                ]\n              },\n              {\n                "@type": "SearchAction",\n                "target": "').concat(originUrl + _constants_linksConstants__WEBPACK_IMPORTED_MODULE_3__/* .linksConstants.DATA_CATALOG_CONNECTORS */ .s.DATA_CATALOG_CONNECTORS, '?search={search_term_string}",\n                "query-input": "required name=search_term_string"\n              }\n            ]\n          }\n        ]\n      }')
            }),
            children
        ]
    });
};
PlatformHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.node,
    description: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.string,
    displayCompanyName: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_6__.PropTypes.string
};


/***/ }),

/***/ 87955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PlatformLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(81043);
// EXTERNAL MODULE: ./src/redux/user/userSlice.js
var userSlice = __webpack_require__(44372);
// EXTERNAL MODULE: ./src/config/appConfig.js
var appConfig = __webpack_require__(84762);
;// CONCATENATED MODULE: ./src/platform/layout/FreeUserBar.jsx




var FreeUserBar = function(param) {
    var userPlan = param.userPlan;
    var dispatch = (0,es/* useDispatch */.I0)();
    var openModal = function() {
        dispatch(userSlice/* userActions.setContactUsModalState */.hI.setContactUsModalState(true));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: userPlan === appConfig/* userPlans.LEAD */.yG.LEAD && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "FreeUserBar",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "You are using a free version of the Demyst Platform. To get started integrating your first Data API, ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: openModal,
                        children: "click here"
                    }),
                    "."
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/redux/user/userSelectors.js
var userSelectors = __webpack_require__(74918);
// EXTERNAL MODULE: ./src/platform/components/formComponents/index.js + 2 modules
var formComponents = __webpack_require__(10005);
// EXTERNAL MODULE: ./src/platform/components/formComponents/RadioButton.jsx
var RadioButton = __webpack_require__(22905);
// EXTERNAL MODULE: ./src/platform/components/Loader/Loader.jsx
var Loader = __webpack_require__(5786);
// EXTERNAL MODULE: ./src/platform/components/MessageBox/MessageBox.jsx
var MessageBox = __webpack_require__(43454);
// EXTERNAL MODULE: ./src/platform/components/buttons/Button.jsx
var Button = __webpack_require__(57);
// EXTERNAL MODULE: ./src/utils/serializeError.js
var serializeError = __webpack_require__(99584);
// EXTERNAL MODULE: ./src/api/operationalDashboardApi.js
var operationalDashboardApi = __webpack_require__(70013);
// EXTERNAL MODULE: ./src/api/userApi.js
var userApi = __webpack_require__(62725);
// EXTERNAL MODULE: ./src/utils/formAttribution.js
var formAttribution = __webpack_require__(64357);
;// CONCATENATED MODULE: ./src/platform/layout/ContactModal.jsx


















var ContactModal = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var userData = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.getUserData */.p.getUserData);
    var ref = (0,react.useState)(0), radioValue = ref[0], setRadioValue = ref[1];
    var ref1 = (0,react.useState)(false), sent = ref1[0], setSent = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,react.useState)(null), error = ref3[0], setError = ref3[1];
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
            var formData, radio, text, dataToSend, formData1, radio1, text1, requestData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        setError(null);
                        setIsLoading(true);
                        _ctx.prev = 3;
                        formData = new FormData(event.target);
                        radio = formData.get("solution_category");
                        text = formData.get("comments");
                        dataToSend = {
                            type: "Platform Qualification Request",
                            formValues: (0,formAttribution/* formAttribution */.e)("Platform Qualification Request")
                        };
                        dataToSend.formValues.email = userData.user.email;
                        dataToSend.formValues.full_name = userData.user.name;
                        dataToSend.formValues.company = userData.organization.name;
                        dataToSend.formValues.category = radio;
                        dataToSend.formValues.message = text;
                        _ctx.next = 15;
                        return userApi/* userApi.sendFrontForm */.B.sendFrontForm(dataToSend);
                    case 15:
                        _ctx.next = 20;
                        break;
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](3);
                        console.log("Failed to send analytics data");
                    case 20:
                        _ctx.prev = 20;
                        formData1 = new FormData(event.target);
                        radio1 = formData1.get("solution_category");
                        text1 = formData1.get("comments");
                        requestData = (0,_object_spread/* default */.Z)({
                            email: userData.user.email,
                            message: text1,
                            name: userData.user.name,
                            company: userData.organization.name,
                            category: radio1
                        }, (0,formAttribution/* formAttribution */.e)("Platform Qualification Request"));
                        _ctx.next = 27;
                        return operationalDashboardApi/* operationalDashboardApi.sendSupportEmail */.w.sendSupportEmail(requestData);
                    case 27:
                        setSent(true);
                        _ctx.next = 33;
                        break;
                    case 30:
                        _ctx.prev = 30;
                        _ctx.t1 = _ctx["catch"](20);
                        setError((0,serializeError/* serializeError */.X)(_ctx.t1));
                    case 33:
                        _ctx.prev = 33;
                        setIsLoading(false);
                        return _ctx.finish(33);
                    case 36:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    17
                ],
                [
                    20,
                    30,
                    33,
                    36
                ]
            ]);
        }));
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var closeModal = function() {
        if (!isLoading) {
            dispatch(userSlice/* userActions.setContactUsModalState */.hI.setContactUsModalState(false));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "ContactModal",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: closeModal,
                className: "ContactModal__background",
                onKeyPress: closeModal,
                role: "button",
                tabIndex: "0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ContactModal__modal",
                children: [
                    !sent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "ContactModal__modal__header",
                                children: "Let's get into production!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "ContactModal__modal__paragraph",
                                children: "We are ready to help accelerate your external data driven application. To get started help us understand a little more about your use case:"
                            }),
                            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ContactModal__loading",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                onSubmit: handleSubmit,
                                className: "ContactModal__form",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                        className: "ContactModal__form__radio",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Category"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                                className: "ContactModal__form__radio__container",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* RadioButton */.E, {
                                                        id: "crime",
                                                        name: "solution_category",
                                                        label: "FinCrime & Fraud",
                                                        value: "FinCrime & Fraud",
                                                        checked: radioValue === 0,
                                                        onChange: function() {
                                                            return setRadioValue(0);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* RadioButton */.E, {
                                                        id: "marketing",
                                                        name: "solution_category",
                                                        label: "Marketing & Sales",
                                                        value: "Marketing & Sales",
                                                        checked: radioValue === 1,
                                                        onChange: function() {
                                                            return setRadioValue(1);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* RadioButton */.E, {
                                                        id: "credit",
                                                        name: "solution_category",
                                                        label: "Credit & Underwriting",
                                                        value: "Credit & Underwriting",
                                                        checked: radioValue === 2,
                                                        onChange: function() {
                                                            return setRadioValue(2);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* RadioButton */.E, {
                                                        id: "data",
                                                        name: "solution_category",
                                                        label: "Data & Analytics",
                                                        value: "Data & Analytics",
                                                        checked: radioValue === 3,
                                                        onChange: function() {
                                                            return setRadioValue(3);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* RadioButton */.E, {
                                                        id: "other",
                                                        name: "solution_category",
                                                        label: "Other",
                                                        value: "Other",
                                                        checked: radioValue === 4,
                                                        onChange: function() {
                                                            return setRadioValue(4);
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formComponents/* TextArea */.Kx, {
                                        name: "comments",
                                        label: "Additional comments"
                                    }),
                                    error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "ContactModal__form__error",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageBox/* MessageBox */._, {
                                            children: error.message
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "ContactModal__form__actions",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            type: "submit",
                                            disabled: isLoading,
                                            children: "Submit"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    sent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "ContactModal__modal__header",
                                children: "Next steps..."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "ContactModal__modal__paragraph",
                                children: [
                                    "Thank you! We will be reviewing your submission and getting back to you shortly. If you have any questions feel free to email us at",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "mailto:support@demystdata.com",
                                        children: "support@demystdata.com"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                onClick: closeModal,
                                children: "Close this window"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js
var react_toastify_esm = __webpack_require__(72132);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/framer-motion.es.js
var framer_motion_es = __webpack_require__(6805);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/platform/utils/useViewport.js + 1 modules
var useViewport = __webpack_require__(72573);
// EXTERNAL MODULE: ./src/platform/assets/svg/DemystLogo.jsx
var DemystLogo = __webpack_require__(45911);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/nav/index.jsx + 1 modules
var nav = __webpack_require__(10130);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/nav_item/index.jsx + 1 modules
var nav_item = __webpack_require__(37462);
// EXTERNAL MODULE: ./src/platform/views/UseCases/UseCasePage.jsx + 4 modules
var UseCasePage = __webpack_require__(91415);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/platform/layout/Navigation/MainNav.jsx









var MainNav = function(param) {
    var mainNavConfig = param.mainNavConfig, closeNavigation = param.closeNavigation;
    var router = (0,next_router.useRouter)();
    var isDashboardItem = function(path) {
        var possibleUseCasePaths = UseCasePage/* possibleUseCaseItemViews.map */.x.map(function(item) {
            return item.name;
        });
        return path === linksConstants/* linksConstants.USE_CASES */.s.USE_CASES && (router.asPath.startsWith(linksConstants/* linksConstants.USE_CASE_PAGE_ROOT */.s.USE_CASE_PAGE_ROOT) || possibleUseCasePaths.some(function(casePath) {
            return router.asPath.startsWith(casePath);
        }));
    };
    var isCatalogItem = function(path) {
        var ref, ref1, ref2;
        return path === linksConstants/* linksConstants.DATA_CATALOG */.s.DATA_CATALOG && (((ref = router.asPath) === null || ref === void 0 ? void 0 : ref.startsWith(linksConstants/* linksConstants.DATA_CATALOG */.s.DATA_CATALOG)) || ((ref1 = router.asPath) === null || ref1 === void 0 ? void 0 : ref1.startsWith(linksConstants/* linksConstants.RECIPE_ROOT */.s.RECIPE_ROOT)) || ((ref2 = router.asPath) === null || ref2 === void 0 ? void 0 : ref2.startsWith(linksConstants/* linksConstants.CONNECTOR_ROOT */.s.CONNECTOR_ROOT)));
    };
    var isProjectsItem = function(path) {
        var ref, ref1, ref2;
        return path === linksConstants/* linksConstants.PROJECTS_ALL */.s.PROJECTS_ALL && (((ref = router.asPath) === null || ref === void 0 ? void 0 : ref.startsWith(linksConstants/* linksConstants.PROJECTS_ALL */.s.PROJECTS_ALL)) || ((ref1 = router.asPath) === null || ref1 === void 0 ? void 0 : ref1.startsWith(linksConstants/* linksConstants.PROJECTS_SANDBOX */.s.PROJECTS_SANDBOX)) || ((ref2 = router.asPath) === null || ref2 === void 0 ? void 0 : ref2.startsWith(linksConstants/* linksConstants.PROJECTS_DEPLOYED */.s.PROJECTS_DEPLOYED)));
    };
    var isInternalDataItem = function(path) {
        var ref;
        return path === linksConstants/* linksConstants.INTERNAL_DATA_CONNECTORS */.s.INTERNAL_DATA_CONNECTORS && ((ref = router.asPath) === null || ref === void 0 ? void 0 : ref.startsWith("/app/internal-data/"));
    };
    var isProjectItem = function(path) {
        var ref;
        return path === linksConstants/* linksConstants.PROJECTS_ALL */.s.PROJECTS_ALL && ((ref = router.asPath) === null || ref === void 0 ? void 0 : ref.startsWith("/app/projects/"));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "MainNav",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(nav/* default */.Z, {
            children: mainNavConfig.filter(function(item) {
                return item.show;
            }).map(function(navItem) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        navItem.label === "Admin" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                        navItem.enabled ? navItem.target_blank ? /*#__PURE__*/ (0,jsx_runtime.jsx)(nav_item/* default */.Z, {
                            href: navItem.path,
                            leftIconSrc: navItem.logo,
                            className: "MainNav__list__item__link",
                            target: "_blank",
                            rel: "noreferrer noopener",
                            children: navItem.label
                        }, navItem.label) : /*#__PURE__*/ (0,jsx_runtime.jsx)(nav_item/* default */.Z, {
                            as: (link_default()),
                            href: navItem.path,
                            leftIconSrc: navItem.logo,
                            className: "MainNav__list__item__link ".concat(isProjectsItem(navItem.path) || isDashboardItem(navItem.path) || isCatalogItem(navItem.path) || isInternalDataItem(navItem.path) || isProjectItem(navItem.path) || navItem.path === router.asPath ? "active" : ""),
                            onClick: closeNavigation,
                            children: navItem.label
                        }, navItem.label) : /*#__PURE__*/ (0,jsx_runtime.jsx)(nav_item/* default */.Z, {
                            leftIconSrc: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiLock */.UIZ, {}),
                            className: "MainNav__list__item__link MainNav__list__item__link--disabled",
                            children: navItem.label
                        }, navItem.label)
                    ]
                });
            })
        })
    });
};
MainNav.propTypes = {
    mainNavConfig: prop_types.PropTypes.array
};

// EXTERNAL MODULE: ./node_modules/lodash.difference/index.js
var lodash_difference = __webpack_require__(61478);
var lodash_difference_default = /*#__PURE__*/__webpack_require__.n(lodash_difference);
// EXTERNAL MODULE: ./src/utils/helpers.js
var helpers = __webpack_require__(8364);
;// CONCATENATED MODULE: ./src/platform/layout/Navigation/subNavs/SubNav.jsx



var SubNav = function(param) {
    var title = param.title, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: (0,clsx_m/* default */.Z)("SubNav", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "SubNav__header",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "SubNav__list",
                children: children
            })
        ]
    });
};
SubNav.propTypes = {
    children: prop_types.PropTypes.node,
    className: prop_types.PropTypes.string,
    title: prop_types.PropTypes.string
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/platform/layout/Navigation/subNavs/SubNavItem.jsx










var SubNavItem = function(param) {
    var activeUrl = param.activeUrl, path = param.path, label = param.label, _exact = param.exact, exact = _exact === void 0 ? false : _exact, children = param.children, className = param.className, onClick = param.onClick;
    var isUseCasesPath = path.indexOf(linksConstants/* linksConstants.USE_CASES */.s.USE_CASES) !== -1;
    var isAllUseCasesPath = path.indexOf(linksConstants/* linksConstants.ALL_USE_CASES */.s.ALL_USE_CASES) !== -1;
    var router = (0,next_router.useRouter)();
    var isActive = isNavItemActive({
        urls: [
            path
        ].concat((0,_to_consumable_array/* default */.Z)((0,helpers/* toArray */.qo)(activeUrl))),
        pathname: router.asPath,
        exact: exact
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: (0,clsx_m/* default */.Z)("SubNavItem", className),
        children: [
            isUseCasesPath && !isAllUseCasesPath ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "SubNavItem__link",
                children: label
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: path,
                className: (0,clsx_m/* default */.Z)("SubNavItem__link", isActive && "SubNavItem__link--active"),
                onClick: onClick,
                children: label
            }),
            children && /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* AnimatePresence */.M_, {
                initial: false,
                children: isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* motion.ul */.ww.ul, {
                    className: "SubNavItem__subItemsList",
                    initial: "collapsed",
                    animate: "open",
                    exit: "collapsed",
                    variants: {
                        open: {
                            opacity: 1,
                            height: "auto"
                        },
                        collapsed: {
                            opacity: 0,
                            height: 0
                        }
                    },
                    transition: {
                        duration: 0.3,
                        type: "tween"
                    },
                    children: children
                }, "subItems")
            })
        ]
    });
};
SubNavItem.propTypes = {
    activeUrl: prop_types.PropTypes.oneOfType([
        prop_types.PropTypes.string,
        prop_types.PropTypes.array
    ]),
    children: prop_types.PropTypes.node,
    className: prop_types.PropTypes.string,
    label: prop_types.PropTypes.oneOfType([
        prop_types.PropTypes.string,
        prop_types.PropTypes.node
    ]),
    path: prop_types.PropTypes.string
};

;// CONCATENATED MODULE: ./src/platform/layout/Navigation/subNavs/KnowledgeCenterSubNav.jsx







var knowledgeCenterSubNavConfig = [
    {
        label: "All Categories",
        path: linksConstants/* linksConstants.KNOWLEDGE_CENTER */.s.KNOWLEDGE_CENTER,
        exact: true
    },
    {
        label: "Demyst Solutions",
        path: "".concat(linksConstants/* linksConstants.KNOWLEDGE_CENTER */.s.KNOWLEDGE_CENTER, "/category/solutions"),
        activeUrl: "".concat(linksConstants/* linksConstants.KNOWLEDGE_CENTER */.s.KNOWLEDGE_CENTER, "/solutions"),
        exact: false
    },
    {
        label: "Discovery",
        path: "".concat(linksConstants/* linksConstants.KNOWLEDGE_CENTER */.s.KNOWLEDGE_CENTER, "/category/discovery"),
        activeUrl: "".concat(linksConstants/* linksConstants.KNOWLEDGE_CENTER */.s.KNOWLEDGE_CENTER, "/discovery"),
        exact: false
    },
    {
        label: "Production",
        path: "".concat(linksConstants/* linksConstants.KNOWLEDGE_CENTER */.s.KNOWLEDGE_CENTER, "/category/production"),
        activeUrl: "".concat(linksConstants/* linksConstants.KNOWLEDGE_CENTER */.s.KNOWLEDGE_CENTER, "/production"),
        exact: false
    },
    {
        label: "Compliance",
        path: "".concat(linksConstants/* linksConstants.KNOWLEDGE_CENTER */.s.KNOWLEDGE_CENTER, "/category/compliance"),
        activeUrl: "".concat(linksConstants/* linksConstants.KNOWLEDGE_CENTER */.s.KNOWLEDGE_CENTER, "/compliance"),
        exact: false
    }, 
];
var KnowledgeCenterSubNav = function() {
    var userData = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.getUserData */.p.getUserData);
    var parsedKnowledgeCenterSubNavConfig = knowledgeCenterSubNavConfig.map(function(item) {
        return parseNavConfigurationItem(item, userData.user);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubNav, {
        title: "Knowledge Center",
        children: parsedKnowledgeCenterSubNavConfig.map(function(item) {
            if (item.show === false) return null;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubNavItem, {
                path: item.path,
                activeUrl: item.activeUrl,
                label: item.label,
                exact: item.exact
            }, item.label);
        })
    });
};

// EXTERNAL MODULE: ./src/utils/hooks/useShowPricing.js
var useShowPricing = __webpack_require__(49591);
// EXTERNAL MODULE: ./src/landingPage/datasets/footerMenu.js
var footerMenu = __webpack_require__(92064);
// EXTERNAL MODULE: ./src/platform/layout/Navigation/utils.js
var utils = __webpack_require__(91313);
;// CONCATENATED MODULE: ./src/platform/layout/Navigation/Navigation.jsx






















var mainNavConfiguration = [
    {
        label: "Home",
        path: linksConstants/* linksConstants.PLATFORM_HOME */.s.PLATFORM_HOME,
        logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiHome */.m6D, {})
    },
    {
        label: "Connectors",
        path: linksConstants/* linksConstants.DATA_CATALOG */.s.DATA_CATALOG,
        logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiBookOpen */.hbr, {}),
        skip_before_action_authenticate_user: true
    },
    {
        label: "Data APIs",
        path: linksConstants/* linksConstants.USE_CASES */.s.USE_CASES,
        logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiActivity */.bAx, {})
    },
    {
        label: "Projects",
        path: linksConstants/* linksConstants.PROJECTS_ALL */.s.PROJECTS_ALL,
        logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiBook */.yK7, {})
    },
    {
        label: "Data Shares",
        path: linksConstants/* linksConstants.DATA_SHARE */.s.DATA_SHARE,
        logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiPieChart */.CFv, {}),
        permissions: [
            appConfig/* userPermissions.canShowAdmin */.NE.canShowAdmin
        ]
    },
    {
        label: "Internal Data",
        path: linksConstants/* linksConstants.INTERNAL_DATA_CONNECTORS */.s.INTERNAL_DATA_CONNECTORS,
        logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiZap */.Wqx, {})
    },
    {
        label: "Admin",
        path: linksConstants/* linksConstants.SETTINGS */.s.SETTINGS,
        logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiSettings */.nbt, {}),
        permissions: [
            appConfig/* userPermissions.canCreateUsers */.NE.canCreateUsers
        ]
    },
    {
        label: "File Transfers",
        path: linksConstants/* linksConstants.FILE_TRANSFERS */.s.FILE_TRANSFERS,
        logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiDatabase */.bGz, {}),
        permissions: [
            appConfig/* userPermissions.canShowFileTransfers */.NE.canShowFileTransfers
        ]
    },
    {
        label: "Knowledge Center",
        path: linksConstants/* linksConstants.KNOWLEDGE_CENTER */.s.KNOWLEDGE_CENTER,
        logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiHelpCircle */.bax, {}),
        show: false,
        subNav: KnowledgeCenterSubNav
    },
    {
        label: "Documentation",
        path: "https://docs.demyst.com/",
        logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiCode */.xqv, {}),
        target_blank: true,
        skip_before_action_authenticate_user: true
    },
    {
        label: "Reports Monitor",
        path: linksConstants/* linksConstants.REPORTS_MONITOR */.s.REPORTS_MONITOR,
        logo: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiZoomIn */.SJS, {})
    }, 
];
var isItemEnabled = function(item, user) {
    if (!user && !item.skip_before_action_authenticate_user) {
        return false;
    }
    return item.enabled !== false;
};
var checkUserPermissions = function(item, userPermissions) {
    var ref;
    // if item has no permissions specified - pass;
    if (!((ref = item.permissions) === null || ref === void 0 ? void 0 : ref.length)) return true;
    // if item has permissions specified but no user permissions passed - fail;
    if (!userPermissions) return false;
    // filter user permissions and create an array consisting of permissions that are set to true
    var usersTruePermissions = Object.keys(userPermissions).filter(function(key) {
        return userPermissions[key];
    });
    // calculate difference between item's specified permissions and user permissions;
    var permissionsDifference = lodash_difference_default()(item.permissions, usersTruePermissions);
    // if there is no difference between permissions, `permissionsDifference` should be equal to
    // an empty array.
    return Array.isArray(permissionsDifference) && permissionsDifference.length === 0;
};
var checkUserPlan = function(item, userPlan) {
    var ref;
    // if item has no plan specified - pass;
    if (!((ref = item.permittedUserPlans) === null || ref === void 0 ? void 0 : ref.length)) return true;
    // if item has plans specified but no user plan passed - fail;
    if (!userPlan) return false;
    // check if any of permitted plans equals to user's plan
    return item.permittedUserPlans.some(function(plan) {
        return plan === userPlan;
    });
};
var isItemVisible = function(item, user, userPlan, userData) {
    if (item.label === "Data Shares") {
        if ((userData === null || userData === void 0 ? void 0 : userData.data_share) !== true) {
            return false;
        }
    }
    if (false) {}
    if (item.path === linksConstants/* linksConstants.PROJECTS_ALL */.s.PROJECTS_ALL && window.localStorage.getItem("projects_visible") !== "true" || item.path === linksConstants/* linksConstants.INTERNAL_DATA_CONNECTORS */.s.INTERNAL_DATA_CONNECTORS && window.localStorage.getItem("internal_data_visible") !== "true" || item.path === linksConstants/* linksConstants.REPORTS_MONITOR */.s.REPORTS_MONITOR && window.localStorage.getItem("reports_monitor") !== "true") {
        return false;
    }
    // if `show` is set to `false` in configuration, never show this item;
    if (item.show === false) {
        return false;
    }
    if (user == null) {
        return item.skip_before_action_authenticate_user;
    }
    var permissionsCheckPassed = checkUserPermissions(item, user.permissions);
    var planCheckPassed = checkUserPlan(item, userPlan);
    return permissionsCheckPassed && planCheckPassed;
};
var parseNavConfigurationItem = function(item, user, userPlan, userData) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
        enabled: isItemEnabled(item, user),
        show: isItemVisible(item, user, userPlan, userData)
    });
};
// Simple wrapper over react router`s `matchPath` function. Checks if any of the urls provided
// is currently active.
var isNavItemActive = function(param) {
    var urls = param.urls, pathname = param.pathname, _exact = param.exact, exact = _exact === void 0 ? false : _exact;
    return (0,helpers/* toArray */.qo)(urls).some(function(url) {
        return (0,utils/* matchPath */.L)(pathname, {
            path: url,
            exact: exact
        });
    });
};
var Navigation = function() {
    var ref = (0,react.useState)(true), showNavigation = ref[0], setShowNavigation = ref[1];
    var tablet_landscape = (0,useViewport/* useViewport */.S)().tablet_landscape;
    var userData = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.getUserData */.p.getUserData);
    var userPlan = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.getUserPlan */.p.getUserPlan);
    var showPricing = (0,useShowPricing/* useShowPricing */.F)();
    var router = (0,next_router.useRouter)();
    var currentYear = new Date().getFullYear();
    (0,react.useEffect)(function() {
        if (tablet_landscape) {
            setShowNavigation(false);
        } else {
            setShowNavigation(true);
        }
    }, [
        tablet_landscape
    ]);
    var toggleNavigation = function() {
        setShowNavigation(function(value) {
            return !value;
        });
    };
    var closeNavigation = function() {
        if (tablet_landscape) {
            setShowNavigation(false);
        }
    };
    var parsedMainNavConfig = mainNavConfiguration.map(function(item) {
        if (item.label === "Billing") item.enabled = showPricing;
        if (item.label === "Billing" && userPlan === "unverified") item.enabled = false;
        return parseNavConfigurationItem(item, userData.user, userPlan, userData);
    });
    var activeMainNavItem = (0,react.useMemo)(function() {
        return parsedMainNavConfig.find(function(item) {
            return isNavItemActive({
                urls: [
                    item.path
                ],
                pathname: router.asPath
            });
        });
    }, [
        router.asPath,
        parsedMainNavConfig
    ]);
    var prevFirstPath = (0,react.useRef)();
    var prevSecondPath = (0,react.useRef)();
    (0,react.useEffect)(function() {
        var ref = (0,_sliced_to_array/* default */.Z)(window.location.pathname.split("/"), 4), firstPath = ref[2], secondPath = ref[3];
        // Only close navigation if second path and second path only changed
        if (firstPath === prevFirstPath.current && prevSecondPath.current !== undefined) {
            closeNavigation();
        }
        prevFirstPath.current = firstPath;
        prevSecondPath.current = secondPath;
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("NavigationWrapper", showNavigation && "NavigationWrapper--showNavigation"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "Navigation",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "Navigation__header",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: userData.user ? linksConstants/* linksConstants.USE_CASES */.s.USE_CASES : "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DemystLogo/* DemystLogo */.w, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainNav, {
                            mainNavConfig: parsedMainNavConfig,
                            closeNavigation: closeNavigation
                        }),
                        (activeMainNavItem === null || activeMainNavItem === void 0 ? void 0 : activeMainNavItem.subNav) && /*#__PURE__*/ (0,jsx_runtime.jsx)(activeMainNavItem.subNav, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "Navigation__footer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "Navigation__footer__content",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "\xa9 ",
                                            currentYear,
                                            " DemystData, Ltd"
                                        ]
                                    }),
                                    footerMenu/* footerMenu.columns.filter */.T.columns.filter(function(c) {
                                        return c.header === "Legal";
                                    }).map(function(c) {
                                        return c.items.filter(function(l) {
                                            return !l.hideShort;
                                        }).map(function(link, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    i !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "Navigation__footer__content__spacer"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        target: "_blank",
                                                        href: link.url,
                                                        children: link.shortName
                                                    })
                                                ]
                                            }, link.name);
                                        });
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: (0,clsx_m/* default */.Z)("NavigationMobileToggleButton", showNavigation && "NavigationMobileToggleButton--active"),
                onClick: toggleNavigation,
                title: showNavigation ? "Close" : "Menu",
                children: showNavigation ? /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiX */.q5L, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiMenu */.cur, {})
            })
        ]
    });
};
Navigation.propTypes = {};

// EXTERNAL MODULE: ./src/redux/Provider.js
var Provider = __webpack_require__(66884);
// EXTERNAL MODULE: ./node_modules/react-helmet-async/lib/index.module.js
var index_module = __webpack_require__(70405);
// EXTERNAL MODULE: ./src/platform/layout/UnverifiedForm.jsx
var UnverifiedForm = __webpack_require__(34102);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/button/index.jsx
var ui_button = __webpack_require__(58278);
;// CONCATENATED MODULE: ./src/platform/layout/UnverifiedDrawer.jsx







var UnverifiedDrawer = function() {
    var ref = (0,react.useState)(""), response = ref[0], setResponse = ref[1];
    var ref1 = (0,react.useState)(false), isMounted = ref1[0], setIsMounted = ref1[1];
    var userPlan = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.getUserPlan */.p.getUserPlan);
    var ref2 = (0,react.useState)(false), showModal = ref2[0], setShowModal = ref2[1];
    (0,react.useEffect)(function() {
        if (response !== "") {
            setTimeout(function() {
                setResponse("");
            }, 2000);
        }
    }, [
        response
    ]);
    (0,react.useEffect)(function() {
        setIsMounted(true);
        return function() {
            return setIsMounted(false);
        };
    }, []);
    return userPlan === appConfig/* userPlans.UNVERIFIED */.yG.UNVERIFIED && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnverifiedForm/* default */.Z, {
                setResponse: setResponse,
                open: showModal,
                onBackdropClick: function() {
                    return setShowModal(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "UnverifiedDrawer__container ".concat(isMounted && "mounted"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "UnverifiedDrawer__title",
                        children: [
                            "Your organization is ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Unverified"
                            }),
                            " and will only return mocked data."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "UnverifiedDrawer__bottom",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "UnverifiedDrawer__paragraph",
                                children: "Contact sales to verify your organization. Once completed, you will have full access to the datasets in the Demyst platform."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* default */.Z, {
                                onClick: function() {
                                    return setShowModal(true);
                                },
                                children: "Contact Sales"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-click-away-listener/dist/react-click-away-listener.es.js
var react_click_away_listener_es = __webpack_require__(55078);
// EXTERNAL MODULE: ./src/platform/layout/DevTools.jsx + 1 modules
var DevTools = __webpack_require__(77721);
// EXTERNAL MODULE: ./src/platform/utils/notify.js
var notify = __webpack_require__(29019);
// EXTERNAL MODULE: ./node_modules/copy-to-clipboard/index.js
var copy_to_clipboard = __webpack_require__(20640);
var copy_to_clipboard_default = /*#__PURE__*/__webpack_require__.n(copy_to_clipboard);
;// CONCATENATED MODULE: ./src/platform/layout/UserMenu.jsx






















var UserMenuContent = function(param) {
    var closeUserMenu = param.closeUserMenu;
    var ref, ref1, ref2, ref3;
    var userData = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.getUserData */.p.getUserData);
    var dispatch = (0,es/* useDispatch */.I0)();
    var isAdminUserUsingAccountInClientOrganization = !!(userData === null || userData === void 0 ? void 0 : (ref = userData.user) === null || ref === void 0 ? void 0 : ref.created_by_administrative_user);
    var isDemystOrg = userData === null || userData === void 0 ? void 0 : (ref1 = userData.organization) === null || ref1 === void 0 ? void 0 : ref1.is_demyst_org;
    var isAdmin = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.isAdmin */.p.isAdmin);
    var menuItems = [
        {
            label: isAdminUserUsingAccountInClientOrganization ? "Quit back to ".concat(userData.user.created_by_administrative_user.email) : "Log Out",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiLogOut */.xqh, {}),
            onClick: function() {
                if (isAdminUserUsingAccountInClientOrganization) {
                    var password = prompt("Hold up \uD83D\uDEA8 To go back to your admin account, we gonna need yo password \uD83D\uDD10");
                    dispatch(userSlice/* userThunks.logoutAdminUserUsingAccountInClientOrganization */.Dw.logoutAdminUserUsingAccountInClientOrganization({
                        organization_id: userData.organization.id,
                        password: password
                    }));
                } else {
                    dispatch(userSlice/* userThunks.logoutUser */.Dw.logoutUser());
                }
                closeUserMenu();
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "UserMenuContent",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "UserMenuContent__list",
                children: [
                    isDemystOrg && isAdmin && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: "UserMenuContent__list__item",
                        href: "".concat(appConfig/* appConfig.DEMYST_CONSOLE_API_URL */.eG.DEMYST_CONSOLE_API_URL, "/admin"),
                        rel: "noopener noreferrer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiActivity */.bAx, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "UserMenuContent__list__item--label",
                                children: "Admin Tools"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        className: "UserMenuContent__list__item",
                        href: linksConstants/* linksConstants.SETTINGS_PROFILE */.s.SETTINGS_PROFILE,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiUser */.fzv, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "UserMenuContent__list__item--label",
                                children: "Profile"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: "UserMenuContent__list__item",
                        href: "#",
                        onClickCapture: function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
                                var data, jwt;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            e.preventDefault();
                                            _ctx.next = 3;
                                            return userApi/* userApi.getJWT */.B.getJWT();
                                        case 3:
                                            data = _ctx.sent.data;
                                            jwt = data.jwt;
                                            copy_to_clipboard_default()(jwt);
                                            notify/* notify.success */.h.success("JWT copied to clipboard");
                                        case 7:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(e) {
                                return _ref.apply(this, arguments);
                            };
                        }(),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiCopy */.C3L, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "UserMenuContent__list__item--label",
                                children: "Copy JWT"
                            })
                        ]
                    }),
                    (userData === null || userData === void 0 ? void 0 : (ref2 = userData.organization) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.organizations_allowed_to_switch_to) === null || ref3 === void 0 ? void 0 : ref3.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        className: "UserMenuContent__list__item",
                        href: linksConstants/* linksConstants.SWITCH_ORGANIZATON */.s.SWITCH_ORGANIZATON,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiShuffle */.M67, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "UserMenuContent__list__item--label",
                                children: "Switch Organization"
                            })
                        ]
                    }) : null,
                    menuItems.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "UserMenuContent__list__item",
                            onClick: item.onClick,
                            children: [
                                item.icon,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "UserMenuContent__list__item--label",
                                    children: item.label
                                })
                            ]
                        }, item.label);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DevTools.DevTools, {})
        ]
    });
};
UserMenuContent.propTypes = {
    closeUserMenu: prop_types.PropTypes.func.isRequired
};
var UserMenuPopup = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var closeUserMenu = param.closeUserMenu;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* motion.div */.ww.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        className: "UserMenuPopup"
    }, appConfig/* animatePresenceConfig */.Rr), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMenuContent, {
            closeUserMenu: closeUserMenu
        })
    }));
});
UserMenuPopup.displayName = "UserMenuPopup";
UserMenuPopup.propTypes = {
    closeUserMenu: prop_types.PropTypes.func
};
var UserMenuFullScreen = function(param) {
    var closeUserMenu = param.closeUserMenu;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(framer_motion_es/* motion.div */.ww.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "UserMenuFullScreen"
    }, appConfig/* animatePresenceConfig */.Rr), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "UserMenuFullScreen__header",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "UserMenuFullScreen__header__closeButton",
                    onClick: closeUserMenu,
                    title: "Close",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiX */.q5L, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMenuContent, {
                closeUserMenu: closeUserMenu
            })
        ]
    }));
};
UserMenuFullScreen.propTypes = {
    closeUserMenu: prop_types.PropTypes.func
};
var UserMenu = function() {
    var ref, ref1, ref2, ref3, ref4;
    var userData = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.getUserData */.p.getUserData);
    var ref5 = (0,react.useState)(false), showUserMenu = ref5[0], setShowUserMenu = ref5[1];
    var mobile = (0,useViewport/* useViewport */.S)().mobile;
    var toggleUserMenu = function() {
        setShowUserMenu(function(value) {
            return !value;
        });
    };
    var closeUserMenu = function() {
        setShowUserMenu(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "UserMenu",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: (0,clsx_m/* default */.Z)("UserMenu__button", showUserMenu && "UserMenu__button--active"),
                onClick: toggleUserMenu,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "UserMenu__button__logo",
                        children: (userData === null || userData === void 0 ? void 0 : (ref = userData.organization) === null || ref === void 0 ? void 0 : ref.collapsed_logo_url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: userData === null || userData === void 0 ? void 0 : (ref1 = userData.organization) === null || ref1 === void 0 ? void 0 : ref1.collapsed_logo_url,
                            alt: userData === null || userData === void 0 ? void 0 : (ref2 = userData.organization) === null || ref2 === void 0 ? void 0 : ref2.name
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiUser */.fzv, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "UserMenu__button__symbol",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiMenu */.cur, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "UserMenu__button__info",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: userData === null || userData === void 0 ? void 0 : (ref3 = userData.user) === null || ref3 === void 0 ? void 0 : ref3.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: userData === null || userData === void 0 ? void 0 : (ref4 = userData.organization) === null || ref4 === void 0 ? void 0 : ref4.name
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* AnimatePresence */.M_, {
                children: showUserMenu ? mobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMenuFullScreen, {
                    closeUserMenu: closeUserMenu
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react_click_away_listener_es/* default */.Z, {
                    onClickAway: closeUserMenu,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMenuPopup, {
                        closeUserMenu: closeUserMenu
                    })
                }) : null
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/platform/assets/svg/DemystLogoMobile.jsx

function DemystLogoMobile() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "24",
        height: "40",
        viewBox: "0 0 8 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.23483 5.99324C7.20631 6.46015 7.03065 6.99462 6.15689 7.26786C4.6901 7.72576 3.85687 8.73915 3.5386 9.05442C3.14375 9.44627 2.83298 9.98974 2.61529 10.7389C2.34505 11.6637 2.10484 12 1.2611 12C0.564494 12 0 11.4355 0 10.7389C0 10.0423 0.415864 9.57238 1.2611 9.47779C3.25935 9.2556 4.71262 7.93294 4.71262 6.02627V5.97523C4.71262 4.06856 3.25935 2.7459 1.2611 2.52371C0.415864 2.42762 0 1.95771 0 1.2611C0 0.564494 0.564494 0 1.2611 0C2.10484 0 2.49668 0.48042 2.6288 1.2611C2.73689 1.90066 3.14375 2.55373 3.5386 2.94558C3.85687 3.26235 4.6901 4.27424 6.15689 4.73214C7.03065 5.00388 7.20631 5.53985 7.23483 6.00525V5.99324Z",
                fill: "#17009A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.917599 7.25992H1.18633C1.86193 7.25992 2.45344 6.75097 2.49398 6.07688C2.53752 5.34574 1.95801 4.73771 1.23438 4.73771C1.23438 4.73771 0.959636 4.7302 0.881567 4.73771C0.594816 4.76473 0.383131 4.96891 0.344097 5.24966C0.291551 5.63249 0.291551 6.34862 0.344097 6.71494C0.389136 7.0122 0.605326 7.23289 0.917599 7.25992Z",
                fill: "#17009A"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/utils/hooks/useInterval.js

/**
 * Author: Dan Abramov.
 * Source: https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 * @param callback
 * @param delay
 */ function useInterval(callback, delay) {
    var savedCallback = (0,react.useRef)();
    // Remember the latest callback.
    (0,react.useEffect)(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0,react.useEffect)(function() {
        var tick = function tick() {
            savedCallback.current();
        };
        if (delay !== null) {
            var id = setInterval(tick, delay);
            return function() {
                return clearInterval(id);
            };
        }
    }, [
        delay
    ]);
}

// EXTERNAL MODULE: ./node_modules/@wojtekmaj/react-hooks/dist/esm/useMatchMedia.js
var useMatchMedia = __webpack_require__(24284);
;// CONCATENATED MODULE: ./src/platform/layout/UnverifiedButton.jsx








var UnverifiedButton = function(param) {
    var _isSearchVisible = param.isSearchVisible, isSearchVisible = _isSearchVisible === void 0 ? false : _isSearchVisible;
    var ref = (0,react.useState)(""), response = ref[0], setResponse = ref[1];
    var ref1 = (0,react.useState)(false), showModal = ref1[0], setShowModal = ref1[1];
    var isDesktop = (0,useMatchMedia/* default */.Z)("screen and (min-width: 960px)");
    var isSmallMobile = (0,useMatchMedia/* default */.Z)("screen and (max-width: 300px)");
    var userPlan = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.getUserPlan */.p.getUserPlan);
    (0,react.useEffect)(function() {
        if (response !== "") {
            setTimeout(function() {
                setResponse("");
            }, 2000);
        }
    }, [
        response
    ]);
    return userPlan === appConfig/* userPlans.UNVERIFIED */.yG.UNVERIFIED && !isSearchVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            response !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "UnverifiedButton__response",
                children: response
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnverifiedForm/* default */.Z, {
                setResponse: setResponse,
                open: showModal,
                onBackdropClick: function() {
                    return setShowModal(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: function() {
                    return setShowModal(true);
                },
                className: !isSmallMobile ? "UnverifiedButton" : "smallScreenButton",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiInfo */.H33, {}),
                    !isSmallMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "UnverifiedButton__text",
                                children: [
                                    isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "Your organization is ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Unverified"
                                            })
                                        ]
                                    }),
                                    !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Unverified"
                                        })
                                    })
                                ]
                            }),
                            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "UnverifiedButton__cta",
                                children: "Click here to contact sales"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/redux/productsCatalog/productsCatalogSelectors.js
var productsCatalogSelectors = __webpack_require__(87751);
// EXTERNAL MODULE: ./src/api/productsCatalogApi.js
var productsCatalogApi = __webpack_require__(43420);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/utils/hooks/useAxiosSource.js
var useAxiosSource = __webpack_require__(94103);
// EXTERNAL MODULE: ./src/config/userTracking.js
var userTracking = __webpack_require__(67474);
// EXTERNAL MODULE: ./src/utils/hooks/useDebounce.js
var useDebounce = __webpack_require__(67086);
// EXTERNAL MODULE: ./src/platform/views/DataCatalog/components/RegionLogo.jsx + 4 modules
var RegionLogo = __webpack_require__(93519);
// EXTERNAL MODULE: ./src/platform/assets/datasourceLogos/demyst.png
var demyst = __webpack_require__(25883);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/string.js
var string = __webpack_require__(46553);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/input/index.jsx + 1 modules
var input = __webpack_require__(72622);
// EXTERNAL MODULE: ./node_modules/dompurify/dist/purify.js
var purify = __webpack_require__(27856);
var purify_default = /*#__PURE__*/__webpack_require__.n(purify);
;// CONCATENATED MODULE: ./src/platform/layout/SearchBar.jsx





























var SearchBarList = function(param) {
    var searchList = param.searchList, type = param.type, hoverOverItem = param.hoverOverItem, searchInputValue = param.searchInputValue, contentNumbers = param.contentNumbers, desiredContent = param.desiredContent, setShowList = param.setShowList, setSearchInputValue = param.setSearchInputValue;
    var router = (0,next_router.useRouter)();
    var userData = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.getUserData */.p.getUserData);
    var previousNumberCount = contentNumbers.filter(function(item, itemIndex) {
        return itemIndex < desiredContent;
    }).reduce(function(acc, value) {
        return acc + value;
    }, 0);
    var currentNumberCount = contentNumbers.filter(function(item, itemIndex) {
        return itemIndex <= desiredContent;
    }).reduce(function(acc, value) {
        return acc + value;
    }, 0);
    var recipePath = function(str) {
        return str.split(" ").map(function(item) {
            return item[0].toLowerCase() + item.slice(1, item.length);
        }).join("-");
    };
    var createPathname = function(param) {
        var type = param.type, item = param.item;
        var link = function() {
            var currentPage = router.asPath;
            var isDataCatalog = currentPage.indexOf(linksConstants/* linksConstants.DATA_CATALOG */.s.DATA_CATALOG) !== -1;
            if (isDataCatalog) {
                var view = currentPage.split("/").reverse()[0];
                switch(view){
                    case "featured":
                        return linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS;
                    case "recipes":
                        return linksConstants/* linksConstants.DATA_CATALOG_RECIPES */.s.DATA_CATALOG_RECIPES;
                    default:
                        return linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS;
                }
            } else {
                return linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS;
            }
        };
        switch(type){
            case "Connector":
                return "".concat(linksConstants/* linksConstants.CONNECTOR_ROOT */.s.CONNECTOR_ROOT, "/").concat(item.id);
            case "Attribute":
                return "".concat(linksConstants/* linksConstants.CONNECTOR_ROOT */.s.CONNECTOR_ROOT, "/").concat(item.table_provider.id);
            case "API Recipe":
                return "".concat(linksConstants/* linksConstants.RECIPE_ROOT */.s.RECIPE_ROOT, "/").concat(item.id, "/").concat(recipePath(item.name));
            case "Data API":
                return "".concat(linksConstants/* linksConstants.USE_CASE_PAGE_ROOT */.s.USE_CASE_PAGE_ROOT, "/").concat(item.id, "/overview");
            default:
                return link();
        }
    };
    var createSearch = function(param) {
        var type = param.type, item = param.item;
        var parsedQs = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
            page: 1,
            search: ""
        });
        if (type === "Source") parsedQs.data_source = item.name;
        if (type === "Region") parsedQs.regions = [
            item.name
        ];
        switch(type){
            case "Connector":
                return;
            case "API Recipe":
                return {
                    channel_id: item.channel_id
                };
            default:
                return parsedQs;
        }
    };
    var linkAction = function(param) {
        var type = param.type, item = param.item, setShowList = param.setShowList, setSearchInputValue = param.setSearchInputValue;
        var ref;
        if (type === "Region" || type === "Source") {
            setSearchInputValue("");
        }
        setShowList(false);
        (0,userTracking/* sendGaEvent */.k8)({
            action: 'Autocomplete Partner "'.concat(item.name, '"'),
            category: "Connector Search"
        }, userData === null || userData === void 0 ? void 0 : (ref = userData.user) === null || ref === void 0 ? void 0 : ref.email);
    };
    return searchList.filter(function(position, positionIndex) {
        return positionIndex >= previousNumberCount && positionIndex < currentNumberCount;
    }).map(function(item, itemIndex) {
        var ref;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)((link_default()), {
            tabIndex: "-1",
            className: "SearchBar__autocomplete__list__item ".concat(itemIndex === 0 && "separator", " ").concat(type.toLowerCase().replace(" ", "_")),
            href: {
                pathname: createPathname({
                    type: type,
                    item: item
                }),
                query: createSearch({
                    type: type,
                    item: item
                }),
                state: {
                    fromSearchbar: true,
                    fetchType: type.toLowerCase()
                }
            },
            onClick: function() {
                return linkAction({
                    type: type,
                    item: item,
                    setShowList: setShowList,
                    setSearchInputValue: setSearchInputValue
                });
            },
            onMouseEnter: function() {
                return hoverOverItem(itemIndex + previousNumberCount);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "SearchBar__autocomplete__list__images ".concat(type.toLowerCase().replace(" ", "_")),
                    children: [
                        type === "API Recipe" && ((ref = item.table_providers) === null || ref === void 0 ? void 0 : ref.filter(function(provider, providerIndex) {
                            return providerIndex < 4;
                        }).map(function(provider) {
                            return provider.logo ? provider.logo.indexOf("blue_dot") === -1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: provider.logo,
                                alt: provider.name.toLowerCase() === "undefined" ? "" : "".concat(provider.name, " logo"),
                                loading: "eager"
                            }, provider.name) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: demyst/* default */.Z,
                                alt: "Demyst logo",
                                width: "16",
                                height: "16"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: demyst/* default */.Z,
                                alt: "Demyst logo",
                                width: "16",
                                height: "16"
                            });
                        })),
                        (type === "Connector" || type === "Source") && (item.logo ? item.logo.indexOf("blue_dot") === -1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: item.logo,
                            alt: item.name.toLowerCase() === "undefined" ? "" : "".concat(item.name, " logo"),
                            loading: "eager"
                        }, item.name) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: demyst/* default */.Z,
                            alt: "Demyst logo",
                            width: "20",
                            height: "20"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: demyst/* default */.Z,
                            alt: "Demyst logo",
                            width: "20",
                            height: "20"
                        })),
                        type === "Attribute" && item.table_provider.logo && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: item.table_provider.logo,
                            alt: item.table_provider.name.toLowerCase() === "undefined" ? "" : "".concat(item.table_provider.name, " logo"),
                            loading: "eager",
                            width: "20",
                            height: "20"
                        }, item.table_provider.name),
                        type === "Region" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionLogo/* RegionLogo */.B, {
                            name: item.name
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DataSourcesListOption, {
                    type: type,
                    dataSource: item,
                    searchValue: purify_default().sanitize(searchInputValue)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                    className: "SearchBar__autocomplete__list__sideType",
                    children: type
                })
            ]
        }, "".concat(item.id, "-").concat(type));
    });
};
var DataSourcesListOption = function(param) {
    var type = param.type, dataSource = param.dataSource, searchValue = param.searchValue;
    var formattedName = function(name) {
        var boldIndex = name.toLowerCase().indexOf(searchValue.toLowerCase());
        var firstPart = boldIndex === -1 ? name : name.substring(0, boldIndex);
        var boldPart = boldIndex === -1 ? "" : name.substring(boldIndex, boldIndex + searchValue.length);
        var secondPart = boldIndex === -1 ? "" : name.substring(boldIndex + searchValue.length, name.length);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            className: "SearchBar__formattedName",
            children: [
                firstPart,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "SearchBar__formattedName--bold",
                    children: boldPart
                }),
                secondPart
            ]
        });
    };
    if (type === "Attribute") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "attribute",
            children: [
                formattedName((0,string/* toNaturalSentence */.GA)(dataSource.table_provider.name)),
                formattedName(dataSource.name)
            ]
        });
    }
    return formattedName(dataSource.alias ? (0,string/* toNaturalSentence */.GA)(dataSource.alias) : (0,string/* toNaturalSentence */.GA)(dataSource.name));
};
var SearchBar = function() {
    var router = (0,next_router.useRouter)();
    // const dispatch = useDispatch();
    var searchString = (0,es/* useSelector */.v9)(function(state) {
        return productsCatalogSelectors/* productsCatalogSelectors.getSearchParams */.y.getSearchParams(state, "search");
    });
    var axiosSource = (0,useAxiosSource/* useAxiosSource */.E)();
    var ref = (0,react.useState)(-1), selectedItem = ref[0], setSelectedItem = ref[1];
    var ref1 = (0,react.useState)(false), showList = ref1[0], setShowList = ref1[1];
    var ref2 = (0,react.useState)([
        0,
        0,
        0,
        0
    ]), searchListContentNumbers = ref2[0], setSearchListContentNumbers = ref2[1];
    var ref3 = (0,react.useState)([]), searchList = ref3[0], setSearchList = ref3[1];
    var ref4 = (0,react.useState)(false), searchListLoading = ref4[0], setSearchListLoading = ref4[1];
    var ref5 = (0,react.useState)(searchString || ""), searchInputValue = ref5[0], setSearchInputValue = ref5[1];
    var debouncedSearchInputValue = (0,useDebounce/* useDebounce */.N)(searchInputValue, 500);
    var userData = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.getUserData */.p.getUserData);
    var onSearchInputChange = function(event) {
        if (showList === false) setShowList(true);
        setSearchInputValue(event);
    };
    var hideList = function(e) {
        var ref;
        if ((e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.id) !== "search") {
            // setSearchInputValue(searchString);
            setShowList(false);
        }
    };
    var onSearchListItemClick = function() {
        setShowList(false);
        setSearchInputValue("");
    };
    var onClearSearch = function() {
        setSearchInputValue("");
        var pathname = router.asPath.split("?")[0];
        if (router.asPath.indexOf("featured") !== -1) pathname = linksConstants/* linksConstants.DATA_CATALOG_CONNECTORS */.s.DATA_CATALOG_CONNECTORS;
        var currentPage = router.asPath;
        var isConnector = currentPage.includes(linksConstants/* linksConstants.CONNECTOR_ROOT */.s.CONNECTOR_ROOT);
        var isUseCase = currentPage.includes(linksConstants/* linksConstants.USE_CASE_PAGE_ROOT */.s.USE_CASE_PAGE_ROOT);
        var isRecipe = currentPage.includes(linksConstants/* linksConstants.RECIPE_ROOT */.s.RECIPE_ROOT);
        if (isConnector || isUseCase || isRecipe) {
        // do nothing
        } else {
            router.replace({
                pathname: pathname,
                state: {
                    fromSearchbar: true,
                    fetchType: "clear"
                },
                query: {
                    search: "",
                    sort: "",
                    direction: "",
                    categories: [],
                    regions: [],
                    data_source: "",
                    tags: [],
                    providers_page: 1,
                    use_cases_page: 1,
                    api_templates_page: 1
                }
            });
        }
    };
    var onSearchClick = function() {
        var ref;
        var pathname = router.pathname === "/app/search-results/[view]" ? router.asPath.split("?")[0] : linksConstants/* linksConstants.ALL_SEARCH_RESULTS */.s.ALL_SEARCH_RESULTS;
        router.replace({
            pathname: pathname,
            state: {
                fromSearchbar: true,
                fetchType: "search"
            },
            query: {
                search: purify_default().sanitize(searchInputValue),
                sort: "",
                direction: "",
                categories: [],
                regions: [],
                data_source: "",
                tags: [],
                providers_page: 1,
                use_cases_page: 1,
                api_templates_page: 1
            }
        });
        (0,userTracking/* sendGaEvent */.k8)({
            action: 'Query "'.concat(searchInputValue, '"'),
            category: "Connector Search"
        }, userData === null || userData === void 0 ? void 0 : (ref = userData.user) === null || ref === void 0 ? void 0 : ref.email);
    };
    var resetHighlights = function() {
        var list = document.getElementById("SearchBar_List");
        if (list) {
            var results = list.getElementsByTagName("a");
            var length = results.length + 1;
            for(var i = 0; i < length - 1; i++){
                results[i].classList.remove("focused");
            }
        }
    };
    var hoverOverItem = function(index) {
        setSelectedItem(index);
    };
    var arrowKeysPressed = function(e) {
        if (e.key === "ArrowDown" || e.key === "ArrowUp") e.preventDefault();
        var list = document.getElementById("SearchBar_List");
        if (list) {
            if (e.key === "ArrowDown") {
                if (selectedItem == searchList.length - 1) {
                    setSelectedItem(-1);
                } else if (selectedItem < searchList.length - 1) {
                    setSelectedItem(selectedItem + 1);
                }
            }
            if (e.key === "ArrowUp") {
                if (selectedItem > -1) {
                    setSelectedItem(selectedItem - 1);
                } else {
                    setSelectedItem(searchList.length - 1);
                }
            }
        }
        if (e.key === "Enter") {
            var ref;
            var isActive = (document === null || document === void 0 ? void 0 : (ref = document.activeElement) === null || ref === void 0 ? void 0 : ref.id) === "search";
            if (showList || isActive) {
                setShowList(false);
                if (selectedItem === -1) {
                    var ref1;
                    onSearchClick();
                    (0,userTracking/* sendGaEvent */.k8)({
                        action: 'Query "'.concat(searchInputValue, '"'),
                        category: "Connector Search"
                    }, userData === null || userData === void 0 ? void 0 : (ref1 = userData.user) === null || ref1 === void 0 ? void 0 : ref1.email);
                } else {
                    var ref2;
                    setSearchInputValue("");
                    var allItems = document.getElementsByClassName("SearchBar__autocomplete__list__item ");
                    if (typeof allItems !== "undefined") {
                        var clickedElement = allItems[selectedItem];
                        if (typeof clickedElement !== "undefined") {
                            clickedElement.click();
                        }
                    }
                    (0,userTracking/* sendGaEvent */.k8)({
                        action: 'Autocomplete Partner "'.concat(searchList[selectedItem].name, '"'),
                        category: "Connector Search"
                    }, userData === null || userData === void 0 ? void 0 : (ref2 = userData.user) === null || ref2 === void 0 ? void 0 : ref2.email);
                }
            }
        }
    };
    (0,react.useEffect)(function() {
        resetHighlights();
        var list = document.getElementById("SearchBar_List");
        var searchAll = document.getElementById("SearchBar_SearchAll");
        if (list) {
            var results = list.getElementsByTagName("a");
            if (results[selectedItem]) {
                var ref;
                (ref = results[selectedItem]) === null || ref === void 0 ? void 0 : ref.classList.add("focused");
                searchAll === null || searchAll === void 0 ? void 0 : searchAll.classList.remove("focused");
            } else {
                searchAll === null || searchAll === void 0 ? void 0 : searchAll.classList.add("focused");
            }
        } else {
            searchAll === null || searchAll === void 0 ? void 0 : searchAll.classList.add("focused");
        }
    }, [
        selectedItem
    ]);
    (0,react.useEffect)(function() {
        if (debouncedSearchInputValue !== "") {
            setSelectedItem(-1);
            var loadList = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var data, dataToSet, dataNumbers;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                axiosSource.cancel();
                                axiosSource.setSource();
                                _ctx.prev = 2;
                                setSearchListLoading(true);
                                _ctx.next = 6;
                                return productsCatalogApi/* productsCatalogApi.autocomplete */.r.autocomplete(purify_default().sanitize(debouncedSearchInputValue), {
                                    cancelToken: axiosSource.getToken()
                                });
                            case 6:
                                data = _ctx.sent.data;
                                // dispatch(allUseCasesActions.setUseCaseSearch(data.data_apis));
                                if (!data.attributes) data.attributes = [];
                                else if (data.attributes.length > 0) {
                                    data.attributes = data.attributes.filter(function(a) {
                                        return !!a.table_provider;
                                    });
                                }
                                dataToSet = [];
                                dataNumbers = [];
                                dataToSet = (0,_to_consumable_array/* default */.Z)(data.data_apis).concat((0,_to_consumable_array/* default */.Z)(data.api_templates), (0,_to_consumable_array/* default */.Z)(data.providers), (0,_to_consumable_array/* default */.Z)(data.data_sources), (0,_to_consumable_array/* default */.Z)(data.data_regions), (0,_to_consumable_array/* default */.Z)(data.attributes));
                                dataNumbers = [
                                    data.data_apis.length,
                                    data.api_templates.length,
                                    data.providers.length,
                                    data.data_sources.length,
                                    data.data_regions.length,
                                    data.attributes.length, 
                                ];
                                // That fragment exists solely to remove Blank recipe from results,
                                // The same one exists in apiTemplatesCatalogSlice.js
                                if (dataToSet.findIndex(function(item) {
                                    return item.name === "Blank";
                                }) !== -1) {
                                    dataToSet = dataToSet.filter(function(item) {
                                        return item.name !== "Blank";
                                    });
                                    dataNumbers[0] -= 1;
                                }
                                // End of that specific fragment
                                setSearchList(dataToSet);
                                setSearchListContentNumbers(dataNumbers);
                                setSearchListLoading(false);
                                _ctx.next = 21;
                                break;
                            case 18:
                                _ctx.prev = 18;
                                _ctx.t0 = _ctx["catch"](2);
                                if (!axios_default().isCancel(_ctx.t0)) {
                                    setSearchListLoading(false);
                                }
                            case 21:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            18
                        ]
                    ]);
                }));
                return function loadList() {
                    return _ref.apply(this, arguments);
                };
            }();
            loadList();
        }
        return function() {
            return setSearchListLoading(false);
        };
    }, [
        debouncedSearchInputValue
    ]);
    (0,react.useEffect)(function() {
        setSearchInputValue(searchString || "");
    }, [
        searchString
    ]);
    (0,react.useEffect)(function() {
        setSearchInputValue(searchInputValue);
    }, [
        router.query
    ]);
    (0,react.useEffect)(function() {
        if (searchString !== "" && searchInputValue === "") {
            onClearSearch();
        }
    }, [
        searchInputValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "SearchBar",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* AnimatePresence */.M_, {
                children: searchInputValue.length >= 2 && showList === true && /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* motion.div */.ww.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, appConfig/* animatePresenceConfig */.Rr), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "SearchBar__autocomplete__info",
                        children: "Hit enter"
                    })
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                autoComplete: "off",
                id: "search",
                name: "search",
                value: searchInputValue,
                defaultValue: "",
                type: "search",
                onChange: onSearchInputChange,
                placeholder: "Search Demyst Platform",
                leftIconSrc: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiSearch */.jRj, {}),
                variant: "regular",
                onClick: function() {
                    return setShowList(true);
                },
                onKeyDown: function(e) {
                    return arrowKeysPressed(e);
                },
                "data-testid": "catalog_search"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* AnimatePresence */.M_, {
                children: showList && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_click_away_listener_es/* default */.Z, {
                    onClickAway: function(e) {
                        return hideList(e);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* motion.div */.ww.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, appConfig/* animatePresenceConfig */.Rr), {
                        className: "MotionElementPopupZIndex",
                        children: searchInputValue.length >= 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "SearchBar__autocomplete",
                            children: [
                                (searchListLoading || searchInputValue !== debouncedSearchInputValue) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                                    className: "SearchBar__autocomplete__loading"
                                }),
                                !searchListLoading && searchList.length !== 0 && searchInputValue === debouncedSearchInputValue && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    className: "SearchBar__autocomplete__list",
                                    id: "SearchBar_List",
                                    "data-testid": "searchbar_list",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBarList, {
                                            type: "Data API",
                                            searchList: searchList,
                                            onSearchListItemClick: onSearchListItemClick,
                                            hoverOverItem: hoverOverItem,
                                            searchInputValue: searchInputValue,
                                            contentNumbers: searchListContentNumbers,
                                            desiredContent: 0,
                                            setShowList: setShowList
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBarList, {
                                            type: "API Recipe",
                                            searchList: searchList,
                                            onSearchListItemClick: onSearchListItemClick,
                                            hoverOverItem: hoverOverItem,
                                            searchInputValue: searchInputValue,
                                            contentNumbers: searchListContentNumbers,
                                            desiredContent: 1,
                                            setShowList: setShowList
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBarList, {
                                            type: "Connector",
                                            searchList: searchList,
                                            onSearchListItemClick: onSearchListItemClick,
                                            hoverOverItem: hoverOverItem,
                                            searchInputValue: searchInputValue,
                                            contentNumbers: searchListContentNumbers,
                                            desiredContent: 2,
                                            setShowList: setShowList
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBarList, {
                                            type: "Source",
                                            searchList: searchList,
                                            onSearchListItemClick: onSearchListItemClick,
                                            hoverOverItem: hoverOverItem,
                                            searchInputValue: searchInputValue,
                                            contentNumbers: searchListContentNumbers,
                                            desiredContent: 3,
                                            setShowList: setShowList,
                                            setSearchInputValue: setSearchInputValue
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBarList, {
                                            type: "Region",
                                            searchList: searchList,
                                            onSearchListItemClick: onSearchListItemClick,
                                            hoverOverItem: hoverOverItem,
                                            searchInputValue: searchInputValue,
                                            contentNumbers: searchListContentNumbers,
                                            desiredContent: 4,
                                            setShowList: setShowList,
                                            setSearchInputValue: setSearchInputValue
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBarList, {
                                            type: "Attribute",
                                            searchList: searchList,
                                            onSearchListItemClick: onSearchListItemClick,
                                            hoverOverItem: hoverOverItem,
                                            searchInputValue: searchInputValue,
                                            contentNumbers: searchListContentNumbers,
                                            desiredContent: 5,
                                            setShowList: setShowList,
                                            setSearchInputValue: setSearchInputValue
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "SearchBar__autocomplete__list",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        id: "SearchBar_SearchAll",
                                        onMouseEnter: function() {
                                            return hoverOverItem(-1);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            id: "SearchBar_SearchAll_button",
                                            onClick: onSearchClick,
                                            onKeyDown: function(e) {
                                                return arrowKeysPressed(e);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Search ",
                                                    searchInputValue
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    }))
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/platform/layout/AppHeader.jsx



















var AppHeader = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var userData = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.getUserData */.p.getUserData);
    var isUserLoggedIn = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.isUserLoggedIn */.p.isUserLoggedIn);
    var showPricing = (0,useShowPricing/* useShowPricing */.F)();
    var ref = (0,react.useState)(false), isSearchVisible = ref[0], setIsSearchVisible = ref[1];
    var mobile = (0,useViewport/* useViewport */.S)().mobile;
    var isSmallMobile = (0,useMatchMedia/* default */.Z)("screen and (max-width: 465px)");
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (isUserLoggedIn && (userData === null || userData === void 0 ? void 0 : (ref = userData.organization) === null || ref === void 0 ? void 0 : ref.credits_or_caps) === "one_credit_to_rule_them_all" && (userData === null || userData === void 0 ? void 0 : (ref1 = userData.organization) === null || ref1 === void 0 ? void 0 : ref1.credits_spent_this_month) == null) {
            dispatch(userSlice/* userThunks.updateUserCreditBalance */.Dw.updateUserCreditBalance());
        }
    }, [
        isUserLoggedIn,
        userData
    ]);
    useInterval(function() {
        return dispatch(userSlice/* userThunks.updateUserCreditBalance */.Dw.updateUserCreditBalance());
    }, 1800000);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: "AppHeader",
        children: [
            mobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "AppHeader__demystLogo",
                children: isSmallMobile && isSearchVisible ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(DemystLogoMobile, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "AppHeader__dynamicContent",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "AppHeader__dynamicContent--mobile",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "AppHeader__dynamicContent__searchBarWrapper ".concat(isSearchVisible ? "open" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    return setIsSearchVisible(!isSearchVisible);
                                },
                                className: "AppHeader__dynamicContent--mobile__buttonStyle",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiSearch */.jRj, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "AppHeader__dynamicContent--desktop",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar, {})
                    })
                ]
            }),
            isUserLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    showPricing && userData.organization.credits_or_caps === "new_credits" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "AppHeader__creditsInfoWrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "AppHeader__creditsInfo AppHeader__creditsInfo--evaluation",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "AppHeader__creditsInfo__value AppHeader__creditsInfo__value--evaluation",
                                        children: (0,helpers/* trimTrailingZeroes */.wG)(userData.organization.evaluation_credits)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "AppHeader__creditsInfo__label AppHeader__creditsInfo__label--long",
                                        children: "Evaluation Credits"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "AppHeader__creditsInfo__label AppHeader__creditsInfo__label--short",
                                        children: "Eval. Credits"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "AppHeader__creditsInfo AppHeader__creditsInfo--production",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "AppHeader__creditsInfo__value AppHeader__creditsInfo__value--production",
                                        children: (0,helpers/* trimTrailingZeroes */.wG)(userData.organization.production_credits)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "AppHeader__creditsInfo__label AppHeader__creditsInfo__label--long",
                                        children: "Production Credits"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "AppHeader__creditsInfo__label AppHeader__creditsInfo__label--short",
                                        children: "Prod. Credits"
                                    })
                                ]
                            })
                        ]
                    }),
                    showPricing && userData.organization.credits_or_caps === "one_credit_to_rule_them_all" && userData.organization.credits_spent_this_month != null && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "AppHeader__creditsInfoWrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "AppHeader__creditsInfo AppHeader__creditsInfo--production",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "AppHeader__creditsInfo__value AppHeader__creditsInfo__value--production",
                                    children: (0,helpers/* trimTrailingZeroes */.wG)(userData.organization.credits_spent_this_month)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "AppHeader__creditsInfo__label AppHeader__creditsInfo__label--long",
                                    children: "Credits Spent this Month"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "AppHeader__creditsInfo__label AppHeader__creditsInfo__label--short",
                                    children: "Credits Spent"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UnverifiedButton, {
                        origin: "desktop"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMenu, {})
                ]
            }),
            !isUserLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "AppHeader__publicHeaderWrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        href: linksConstants/* linksConstants.HOME */.s.HOME,
                        className: "AppHeader__publicHeader__link",
                        children: [
                            "Back To Website",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiExternalLink */.AlO, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: linksConstants/* linksConstants.LOGIN */.s.LOGIN,
                        className: "AppHeader__publicHeader__button",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            variant: "whiteWithShadow",
                            children: "Log In"
                        })
                    })
                ]
            })
        ]
    });
};
AppHeader.propTypes = {
    children: prop_types.PropTypes.node
};

// EXTERNAL MODULE: ./src/utils/hooks/usePathChange.js
var usePathChange = __webpack_require__(2679);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
;// CONCATENATED MODULE: ./src/platform/layout/PlatformLayout.jsx




























function Layout(param) {
    var children = param.children, permissions = param.permissions, isAuthRequired = param.isAuthRequired;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var isUserLoggedIn = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.isUserLoggedIn */.p.isUserLoggedIn);
    var isTosOutdated = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.isTosOutdated */.p.isTosOutdated);
    var userData = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.getUserData */.p.getUserData);
    var hasUserBeenLoggedOutManually = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.hasUserBeenLoggedOutManually */.p.hasUserBeenLoggedOutManually);
    var contactUsModalOpen = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.getContactUsModalState */.p.getContactUsModalState);
    var userPlan = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.getUserPlan */.p.getUserPlan);
    var ref = (0,react.useState)(!isUserLoggedIn), loading = ref[0], setLoading = ref[1];
    var pathname = (0,usePathChange/* default */.Z)();
    (0,react.useEffect)(function() {
        (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, userData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return userApi/* userApi.getUserData */.B.getUserData();
                    case 3:
                        ref = _ctx.sent;
                        userData = ref.data;
                        dispatch(userSlice/* userActions.setUserData */.hI.setUserData({
                            userData: userData
                        }));
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log("No user logged in");
                    case 11:
                        _ctx.prev = 11;
                        setLoading(false);
                        return _ctx.finish(11);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8,
                    11,
                    14
                ]
            ]);
        }))();
    }, []);
    (0,react.useEffect)(function() {
        if (pathname) {
            var cleanPathname = browser_default().sanitize(pathname);
            (0,userTracking/* trackPageView */.Z0)(cleanPathname, "Platform");
        }
    }, [
        pathname
    ]);
    if ( true && !loading) {
        var ref1, ref2, ref3;
        if (isAuthRequired && !isUserLoggedIn) {
            router.push((0,_object_spread/* default */.Z)({
                pathname: linksConstants/* linksConstants.LOGIN */.s.LOGIN
            }, !hasUserBeenLoggedOutManually && {
                state: {
                    redirectTo: window.location
                }
            }));
        }
        if (isAuthRequired && isUserLoggedIn && (userData === null || userData === void 0 ? void 0 : (ref1 = userData.user) === null || ref1 === void 0 ? void 0 : ref1.needs_to_change_password)) {
            router.push(linksConstants/* linksConstants.CHANGE_PASSWORD */.s.CHANGE_PASSWORD);
        }
        if (isUserLoggedIn && (userData === null || userData === void 0 ? void 0 : (ref2 = userData.organization) === null || ref2 === void 0 ? void 0 : ref2.require_two_factor_auth) && !(userData === null || userData === void 0 ? void 0 : (ref3 = userData.user) === null || ref3 === void 0 ? void 0 : ref3.two_factor_auth_active) && (router === null || router === void 0 ? void 0 : router.asPath) !== linksConstants/* linksConstants.SETTINGS_PROFILE */.s.SETTINGS_PROFILE) {
            router.push(linksConstants/* linksConstants.SETTINGS_PROFILE */.s.SETTINGS_PROFILE);
        }
        if (isTosOutdated) {
            router.push(linksConstants/* linksConstants.TOS_ACCEPTANCE */.s.TOS_ACCEPTANCE);
        }
        if (permissions && permissions.length > 0 && isUserLoggedIn) {
            var _user = userData.user, userPermissions = _user.permissions;
            var haveAllPermissions = permissions.reduce(function(havePrevPermissions, currentPermission) {
                return havePrevPermissions && userPermissions[currentPermission];
            }, true);
            if (!haveAllPermissions) {
                router.replace(linksConstants/* linksConstants.ALL_USE_CASES */.s.ALL_USE_CASES);
            }
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* AnimatePresence */.M_, {
                children: contactUsModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* motion.div */.ww.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    className: "MotionElementModalZIndex"
                }, appConfig/* animatePresenceConfig */.Rr), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactModal, {})
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FreeUserBar, {
                userPlan: userPlan
            }),
            isUserLoggedIn && router.pathname !== "/app/settings/general" && /*#__PURE__*/ (0,jsx_runtime.jsx)(UnverifiedDrawer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("PlatformLayout", userPlan === appConfig/* userPlans.LEAD */.yG.LEAD && "small"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {
                        position: "top-center",
                        transition: react_toastify_esm/* Zoom */.LG,
                        autoClose: false,
                        hideProgressBar: true,
                        closeButton: false,
                        pauseOnHover: false,
                        pauseOnFocusLoss: false
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "PlatformLayout__wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppHeader, {}),
                            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "PlatformLayout__loader",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {})
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "PlatformLayout__content",
                                children: children
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function PlatformLayout(param) {
    var children = param.children, initialReduxState = param.initialReduxState, permissions = param.permissions, isAuthRequired = param.isAuthRequired;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Provider/* default.Redux */.Z.Redux, {
        initialReduxState: initialReduxState,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* HelmetProvider */.B6, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
                isAuthRequired: isAuthRequired,
                permissions: permissions,
                children: children
            })
        })
    });
};


/***/ }),

/***/ 34102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _autodisco_src_nemo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _autodisco_src_nemo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_autodisco_src_nemo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(18710);
/* harmony import */ var _UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _components_Modal_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69581);
/* harmony import */ var _demystdata_ui_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58278);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _api_userApi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62725);
/* harmony import */ var _components_Loader_Loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5786);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2777);
/* harmony import */ var _components_formComponents_Select__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50057);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81043);
/* harmony import */ var _redux_user_userSelectors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74918);













var volumeOptions = [
    "Unknown (default)",
    "0 - 10,000 per month",
    "10,001 - 20,000 per month",
    "20,001 - 30,000 per month",
    "30,001 - 40,000 per month",
    "40,001 - 50,000 per month",
    "50,001+ per month", 
];
var UnverifiedForm = function(param) {
    var open = param.open, onBackdropClick = param.onBackdropClick, setResponse = param.setResponse;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(volumeOptions[0]), volume = ref[0], setVolume = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), useCaseDescription = ref1[0], setUseCaseDescription = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), error = ref3[0], setError = ref3[1];
    var ref4 = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useSelector */ .v9)(_redux_user_userSelectors__WEBPACK_IMPORTED_MODULE_9__/* .userSelectors.getUserData */ .p.getUserData), email = ref4.user.email;
    var resetForm = function() {
        setUseCaseDescription(null);
        setLoading(false);
        setError(null);
    };
    var setVolumeOption = function(target) {
        setVolume(target);
    };
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_autodisco_src_nemo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(e) {
            var dataToSend;
            return _autodisco_src_nemo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        resetForm();
                        setLoading(true);
                        _ctx.prev = 3;
                        dataToSend = {
                            type: "unverified_user_contact_sales",
                            formValues: {
                                use_case_description: useCaseDescription,
                                contact_email: email,
                                volume: volume
                            }
                        };
                        _ctx.next = 7;
                        return _api_userApi__WEBPACK_IMPORTED_MODULE_5__/* .userApi.sendFrontForm */ .B.sendFrontForm(dataToSend);
                    case 7:
                        onBackdropClick && onBackdropClick();
                        setResponse("Message sent. We will be in touch shortly.");
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](3);
                        setError(_ctx.t0.message);
                    case 14:
                        _ctx.prev = 14;
                        setLoading(false);
                        return _ctx.finish(14);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    11,
                    14,
                    17
                ]
            ]);
        }));
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Modal_Modal__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u, {
        open: open,
        onBackdropClick: function() {
            resetForm();
            onBackdropClick();
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: (_UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11___default().modal),
            children: [
                loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: (_UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11___default().loading),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Loader_Loader__WEBPACK_IMPORTED_MODULE_6__/* .Loader */ .a, {
                        loading: true
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                    onClick: function() {
                        resetForm();
                        onBackdropClick();
                    },
                    className: (_UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11___default().close),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_12__/* .FiX */ .q5L, {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                    className: (_UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11___default().form),
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                            className: (_UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11___default().title),
                            children: "Verify your organization"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                            className: (_UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11___default().description),
                            children: "Contact sales now and someone on the Demyst team will be in touch to verify your organization and your data use case."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: (_UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11___default().field),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: (_UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11___default().inputTitle),
                                    children: "What is your business use case for Demyst Data APIs?"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("textarea", {
                                    className: (_UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11___default().textArea),
                                    required: true,
                                    value: useCaseDescription,
                                    onChange: function(param) {
                                        var value = param.target.value;
                                        return setUseCaseDescription(value);
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
                                    className: (_UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11___default().infoBox),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_12__/* .FiInfo */ .H33, {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            className: (_UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11___default().infoDescription),
                                            children: "Your business use case is the manner in which you will leverage data to derive insights to answer tangible questions for decision-making. Valid use cases are required to access certain datasets."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: (_UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11___default().field),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: (_UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11___default().inputTitle),
                                    children: "What is your estimated monthly API transaction volume?"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_formComponents_Select__WEBPACK_IMPORTED_MODULE_7__/* .Select */ .P, {
                                    name: "estimated_volume",
                                    value: volume.label,
                                    onChange: function(e) {
                                        return setVolumeOption(e.target.value);
                                    },
                                    children: volumeOptions.map(function(option) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                            children: option
                                        }, option);
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
                                    className: (_UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11___default().infoBox),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_12__/* .FiInfo */ .H33, {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            className: (_UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11___default().infoDescription),
                                            children: "We offer significant discounts on data when run at greater volumes. Demyst returns one record per transaction in Data APIs."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (_UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11___default().error),
                            children: error
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_demystdata_ui_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            type: "submit",
                            className: (_UnverifiedForm_module_less__WEBPACK_IMPORTED_MODULE_11___default().submitButton),
                            variant: "primary",
                            children: "Contact Sales"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (UnverifiedForm);


/***/ }),

/***/ 29019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ notify; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72132);
/* harmony import */ var react_toastify_dist_ReactToastify_min_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91280);
/* harmony import */ var react_toastify_dist_ReactToastify_min_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_toastify_dist_ReactToastify_min_css__WEBPACK_IMPORTED_MODULE_0__);



var notify = {
    default: function _default(content, options) {
        return (0,react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast */ .Am)(content, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            autoClose: 3000,
            closeOnClick: false,
            draggable: false
        }, options));
    },
    success: function success(content, options) {
        return react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.success */ .Am.success(content, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            autoClose: 3000,
            closeOnClick: false,
            draggable: false,
            className: "UseCaseBatchesPage__infobox UseCaseBatchesPage__infobox--success"
        }, options));
    },
    successBatch: function successBatch(content, options) {
        return react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.success */ .Am.success(content, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            closeOnClick: true,
            draggable: false
        }, options));
    },
    error: function error(content, options) {
        return react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.error */ .Am.error(content, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            autoClose: 3000,
            closeOnClick: false,
            draggable: false
        }, options));
    },
    stateful: function stateful(content, options) {
        var toastId = (0,react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast */ .Am)(content !== null && content !== void 0 ? content : "Saving...", options);
        return {
            id: toastId,
            updateSuccess: function updateSuccess(content, options) {
                react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.update */ .Am.update(String(toastId), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                    render: content,
                    type: react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.TYPE.SUCCESS */ .Am.TYPE.SUCCESS,
                    autoClose: 3000,
                    closeOnClick: false,
                    draggable: false
                }, options));
            },
            updateError: function updateError(content, options) {
                react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.update */ .Am.update(String(toastId), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                    render: content,
                    type: react_toastify__WEBPACK_IMPORTED_MODULE_1__/* .toast.TYPE.ERROR */ .Am.TYPE.ERROR,
                    autoClose: 3000,
                    closeOnClick: false,
                    draggable: false
                }, options));
            }
        };
    }
};


/***/ }),

/***/ 72573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ useViewport; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/platform/utils/useMediaQuery.js

/**
 * This hook is a kind of React wrapper over `window.matchMedia` functionality. It receives media
 * query as a parameter and determines if the document matches that query. It also monitors changes
 * in document so it will change the returned value if needed.
 * @param query
 * @returns {boolean}
 */ function useMediaQuery(query) {
    var ref = (0,react.useState)(false), matches = ref[0], setMatches = ref[1];
    (0,react.useEffect)(function() {
        var media = window.matchMedia(query);
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        var listener = function() {
            setMatches(media.matches);
        };
        // older browsers don't have support for`addEventListener` in matchMedia and have to use
        // older "addListener" function
        if (media && media.addEventListener) {
            media.addEventListener("change", listener);
        } else {
            media.addListener(listener);
        }
        return function() {
            if (media && media.removeEventListener) {
                media.removeEventListener("change", listener);
            } else {
                media.removeListener(listener);
            }
        };
    }, [
        matches,
        query
    ]);
    return matches;
}

;// CONCATENATED MODULE: ./src/platform/utils/useViewport.js

var useViewport = function() {
    var desktop_small_min = useMediaQuery("(min-width: 64.001rem)");
    var desktop_min = useMediaQuery("(min-width: 70.001rem)");
    var desktop = useMediaQuery("(max-width: 90rem)");
    var desktop_small = useMediaQuery("(max-width: 70rem)");
    var tablet_landscape = useMediaQuery("(max-width: 64rem)");
    var tablet = useMediaQuery("(max-width: 48rem)");
    var mobile = useMediaQuery("(max-width: 30rem)");
    return {
        desktop_small_min: desktop_small_min,
        desktop_min: desktop_min,
        desktop: desktop,
        desktop_small: desktop_small,
        tablet_landscape: tablet_landscape,
        tablet: tablet,
        mobile: mobile
    };
};


/***/ }),

/***/ 93519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ RegionLogo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/AUFlag.svg
var AUFlag = __webpack_require__(22788);
;// CONCATENATED MODULE: ./src/platform/assets/svg/flags/BLFlag.svg
/* harmony default export */ var BLFlag = ({"src":"/_next/static/media/BLFlag.1066d742.svg","height":480,"width":640});
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/CAFlag.svg
var CAFlag = __webpack_require__(29886);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/DEFlag.svg
var DEFlag = __webpack_require__(57983);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/GlobeFlag.svg
var GlobeFlag = __webpack_require__(29518);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/IDFlag.svg
var IDFlag = __webpack_require__(82183);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/INFlag.svg
var INFlag = __webpack_require__(20744);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/MXFlag.svg
var MXFlag = __webpack_require__(38805);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/NAFlag.svg
var NAFlag = __webpack_require__(13851);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/NZFlag.svg
var NZFlag = __webpack_require__(86578);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/PFlag.svg
var PFlag = __webpack_require__(98367);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/SGFlag.svg
var SGFlag = __webpack_require__(68882);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/UKFlag.svg
var UKFlag = __webpack_require__(57260);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/USFlag.svg
var USFlag = __webpack_require__(77799);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/ESFlag.svg
var ESFlag = __webpack_require__(95629);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/FRFlag.svg
var FRFlag = __webpack_require__(18250);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/VNFlag.svg
var VNFlag = __webpack_require__(37202);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/HKFlag.svg
var HKFlag = __webpack_require__(35686);
// EXTERNAL MODULE: ./src/platform/assets/svg/flags/THFlag.svg
var THFlag = __webpack_require__(68083);
;// CONCATENATED MODULE: ./src/platform/assets/svg/flags/MAFlag.svg
/* harmony default export */ var MAFlag = ({"src":"/_next/static/media/MAFlag.e91d882d.svg","height":480,"width":640});
;// CONCATENATED MODULE: ./src/platform/assets/svg/flags/JPFlag.svg
/* harmony default export */ var JPFlag = ({"src":"/_next/static/media/JPFlag.e6f0e2bf.svg","height":600,"width":900});
;// CONCATENATED MODULE: ./src/platform/assets/svg/flags/TWFlag.svg
/* harmony default export */ var TWFlag = ({"src":"/_next/static/media/TWFlag.6af14d69.svg","height":600,"width":900});
;// CONCATENATED MODULE: ./src/platform/views/DataCatalog/components/RegionLogo.jsx
























var RegionLogo = function(param) {
    var name = param.name, className = param.className;
    switch(name){
        case "Australia":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: AUFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Belarus":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: BLFlag.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Canada":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: CAFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Germany":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: DEFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Global":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: GlobeFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Indonesia":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: IDFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "India":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: INFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Mexico":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: MXFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "North America":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: NAFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "New Zealand":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: NZFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Phillippines":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: PFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Singapore":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: SGFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Spain":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: ESFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "France":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: FRFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Vietnam":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: VNFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Hong Kong":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: HKFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Thailand":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: THFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "United Kingdom":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: UKFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "United States":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: USFlag/* default.src */.Z.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Malaysia":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: MAFlag.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Japan":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: JPFlag.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        case "Taiwan":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: className,
                    src: TWFlag.src,
                    alt: "",
                    height: "18",
                    width: "24"
                });
            }
        default:
            {
                return null;
            }
    }
};
RegionLogo.propTypes = {
    name: prop_types.PropTypes.string
};


/***/ }),

/***/ 91415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ UseCasePage; },
  "x": function() { return /* binding */ possibleUseCaseItemViews; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
// EXTERNAL MODULE: ./src/redux/useCases/singleUseCaseSlice.js + 1 modules
var singleUseCaseSlice = __webpack_require__(53700);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(81043);
// EXTERNAL MODULE: ./src/redux/user/userSelectors.js
var userSelectors = __webpack_require__(74918);
// EXTERNAL MODULE: ./src/platform/components/Loader/Loader.jsx
var Loader = __webpack_require__(5786);
// EXTERNAL MODULE: ./src/platform/layout/PlatformHead.jsx
var PlatformHead = __webpack_require__(75168);
// EXTERNAL MODULE: ./src/platform/components/MessageBox/MessageBox.jsx
var MessageBox = __webpack_require__(43454);
// EXTERNAL MODULE: ./src/platform/components/buttons/LinkButton.jsx
var LinkButton = __webpack_require__(87990);
// EXTERNAL MODULE: ./src/redux/useCases/singleUseCaseSelectors.js
var singleUseCaseSelectors = __webpack_require__(23750);
// EXTERNAL MODULE: ./src/utils/helpers.js
var helpers = __webpack_require__(8364);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/breadcrumbs/index.jsx + 2 modules
var breadcrumbs = __webpack_require__(46362);
;// CONCATENATED MODULE: ./src/platform/views/UseCases/components/UseCasePageHeader.jsx





var UseCasePageHeader = function(param) {
    var activeUseCase = param.activeUseCase, activeChannelsIds = param.activeChannelsIds, className = param.className, children = param.children;
    var channel = activeUseCase.channels.find(function(channel) {
        return channel.id === Number(activeChannelsIds[0]);
    });
    var breadCrumbItems = [
        {
            href: linksConstants/* linksConstants.ALL_USE_CASES */.s.ALL_USE_CASES,
            label: "Data APIs"
        },
        {
            href: null,
            label: activeUseCase === null || activeUseCase === void 0 ? void 0 : activeUseCase.name
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,clsx_m/* default */.Z)("UseCasePageHeader", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "UseCasePageHeader__breadcrumbs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumbs/* default */.Z, {
                    items: breadCrumbItems,
                    variant: "tertiary"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "UseCasePageHeader__info",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "UseCasePageHeader__info__title",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    activeUseCase === null || activeUseCase === void 0 ? void 0 : activeUseCase.name,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "UseCasePageHeader__info__title__hash",
                                        children: " #".concat(activeChannelsIds[0])
                                    })
                                ]
                            }),
                            (channel === null || channel === void 0 ? void 0 : channel.billable_category) === "evaluation" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,clsx_m/* default */.Z)("UseCasePageHeader__info__title__label", "UseCasePageHeader__info__title__label--evaluation"),
                                children: "Evaluation API"
                            }),
                            (channel === null || channel === void 0 ? void 0 : channel.billable_category) === "production" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,clsx_m/* default */.Z)("UseCasePageHeader__info__title__label", "UseCasePageHeader__info__title__label--production"),
                                children: "Production API"
                            })
                        ]
                    }),
                    children
                ]
            })
        ]
    });
};
UseCasePageHeader.propTypes = {
    activeUseCase: prop_types.PropTypes.object,
    children: prop_types.PropTypes.node,
    className: prop_types.PropTypes.string,
    subtitle: prop_types.PropTypes.string
};

// EXTERNAL MODULE: ./src/platform/components/formComponents/index.js + 2 modules
var formComponents = __webpack_require__(10005);
;// CONCATENATED MODULE: ./src/platform/views/UseCases/components/ChannelSwitcher.jsx








var ChannelSwitcher = function(param) {
    var _allowAllChannels = param.allowAllChannels, allowAllChannels = _allowAllChannels === void 0 ? false : _allowAllChannels;
    var dispatch = (0,es/* useDispatch */.I0)();
    var channels = (0,es/* useSelector */.v9)(singleUseCaseSelectors/* singleUseCaseSelectors.getActiveUseCaseChannels */.o.getActiveUseCaseChannels);
    var activeChannelsIds = (0,es/* useSelector */.v9)(singleUseCaseSelectors/* singleUseCaseSelectors.getActiveChannelsIds */.o.getActiveChannelsIds);
    var allChannelsSelected = (0,es/* useSelector */.v9)(singleUseCaseSelectors/* singleUseCaseSelectors.allChannelsSelected */.o.allChannelsSelected);
    var ref = (0,react.useState)(activeChannelsIds[0] || ""), selectedChannelId = ref[0], setSelectedChannelId = ref[1];
    (0,react.useEffect)(function() {
        if (allChannelsSelected && allowAllChannels) {
            setSelectedChannelId("ALL");
        } else {
            setSelectedChannelId(activeChannelsIds[0]);
        }
    }, [
        activeChannelsIds,
        allChannelsSelected
    ]);
    var onChannelChange = function(event) {
        if (event.target.value === "ALL" && allowAllChannels) {
            return dispatch(singleUseCaseSlice/* useCasesActions.selectAllChannels */.BD.selectAllChannels());
        }
        if (event.target.value !== "") {
            return dispatch(singleUseCaseSlice/* useCasesActions.setActiveChannelsIds */.BD.setActiveChannelsIds({
                channelsIds: (0,helpers/* toArray */.qo)(event.target.value)
            }));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "ChannelSwitcher",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(formComponents/* Select */.Ph, {
            id: "channelSelect",
            name: "channelSelect",
            value: selectedChannelId,
            onChange: onChannelChange,
            variant: "whiteWithShadow",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                    value: "",
                    disabled: true,
                    children: "Select API Channel"
                }),
                allowAllChannels && /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                    value: "ALL",
                    children: "All APIs"
                }),
                channels.map(function(channel) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: channel.id,
                        children: channel.aka || channel.name
                    }, channel.id);
                })
            ]
        })
    });
};
ChannelSwitcher.propTypes = {
    allowAllChannels: (prop_types_default()).bool
};

// EXTERNAL MODULE: ./src/platform/components/DatePickers/DateRangePickerComponent.jsx
var DateRangePickerComponent = __webpack_require__(32792);
;// CONCATENATED MODULE: ./src/platform/views/UseCases/components/SingleUseCaseDateRangePicker.jsx





var SingleUseCaseDateRangePicker = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var dateRange = (0,es/* useSelector */.v9)(singleUseCaseSelectors/* singleUseCaseSelectors.getUseCasesPagesDateRange */.o.getUseCasesPagesDateRange);
    var onDateRangeChange = function(dateRange) {
        dispatch(singleUseCaseSlice/* useCasesActions.setDateRange */.BD.setDateRange({
            startDate: dateRange[0],
            endDate: dateRange[1]
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DateRangePickerComponent/* DateRangePickerComponent */.C, {
        startDate: dateRange[0],
        endDate: dateRange[1],
        onApply: onDateRangeChange
    });
};

// EXTERNAL MODULE: ./src/config/appConfig.js
var appConfig = __webpack_require__(84762);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/tabs/index.jsx + 1 modules
var tabs = __webpack_require__(7004);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/tabs_item/index.jsx + 1 modules
var tabs_item = __webpack_require__(16303);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/redux/user/userSlice.js
var userSlice = __webpack_require__(44372);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/redux/useCases/helpers.js
var useCases_helpers = __webpack_require__(44744);
// EXTERNAL MODULE: ./src/api/operationalDashboardApi.js
var operationalDashboardApi = __webpack_require__(70013);
// EXTERNAL MODULE: ./node_modules/papaparse/papaparse.min.js
var papaparse_min = __webpack_require__(57460);
var papaparse_min_default = /*#__PURE__*/__webpack_require__.n(papaparse_min);
// EXTERNAL MODULE: ./src/utils/csv.js
var utils_csv = __webpack_require__(72785);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
// EXTERNAL MODULE: ./src/platform/utils/notify.js
var notify = __webpack_require__(29019);
// EXTERNAL MODULE: ./src/config/userTracking.js
var userTracking = __webpack_require__(67474);
// EXTERNAL MODULE: ./src/platform/components/buttons/Button.jsx
var Button = __webpack_require__(57);
// EXTERNAL MODULE: ./src/utils/serializeError.js
var serializeError = __webpack_require__(99584);
;// CONCATENATED MODULE: ./src/platform/views/UseCases/components/Overview/ChangeVisibilty.jsx












var ChangeVisibility = function(param) {
    var useCase = param.useCase;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var sendChangeVisibilityRequest = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var useCaseId, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        useCaseId = router.query.useCaseId;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return operationalDashboardApi/* operationalDashboardApi.changeUseCaseVisibility */.w.changeUseCaseVisibility(useCaseId);
                    case 4:
                        response = _ctx.sent;
                        notify/* notify.success */.h.success(response.data.message);
                        setTimeout(function() {
                            var fetch = function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                _ctx.next = 2;
                                                return dispatch(singleUseCaseSlice/* useCasesThunks.fetchSingleUseCase */.bY.fetchSingleUseCase({
                                                    useCaseId: useCaseId
                                                }));
                                            case 2:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function fetch() {
                                    return _ref.apply(this, arguments);
                                };
                            }();
                            fetch();
                            router.push(linksConstants/* linksConstants.ALL_USE_CASES */.s.ALL_USE_CASES);
                        }, 1000);
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](1);
                        notify/* notify.error */.h.error((0,serializeError/* serializeError */.X)(_ctx.t0).message);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    9
                ]
            ]);
        }));
        return function sendChangeVisibilityRequest() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "DownloadToCsv",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
            onClick: sendChangeVisibilityRequest,
            variant: "whiteWithShadow",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiEyeOff */.rzC, {}),
                useCase.active ? "Archive" : "Unarchived"
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/platform/views/UseCases/UseCasePage.jsx
































var possibleUseCaseItemViews = [
    {
        label: "Overview",
        name: "overview",
        link: linksConstants/* linksConstants.USE_CASE_OVERVIEW */.s.USE_CASE_OVERVIEW
    },
    {
        label: "Run Transaction",
        name: "tests",
        link: linksConstants/* linksConstants.USE_CASE_TESTS */.s.USE_CASE_TESTS,
        hidden: function hidden(param) {
            var activeUseCase = param.activeUseCase;
            return (activeUseCase === null || activeUseCase === void 0 ? void 0 : activeUseCase.channels[0].single_lookupable) === false;
        }
    },
    {
        label: "Batches",
        name: "batches",
        link: linksConstants/* linksConstants.USE_CASE_BATCHES */.s.USE_CASE_BATCHES
    },
    {
        label: "Reports",
        name: "reports",
        link: linksConstants/* linksConstants.USE_CASE_REPORTS */.s.USE_CASE_REPORTS
    },
    {
        label: "Alerts",
        name: "alerts",
        link: linksConstants/* linksConstants.USE_CASE_ALERTS */.s.USE_CASE_ALERTS
    },
    {
        label: "Error Logs",
        name: "errors",
        link: linksConstants/* linksConstants.USE_CASE_ERRORS */.s.USE_CASE_ERRORS
    },
    {
        label: "Settings",
        name: "settings",
        link: linksConstants/* linksConstants.USE_CASE_SETTINGS */.s.USE_CASE_SETTINGS
    }, 
];
var UseCasePage = function(param) {
    var children = param.children;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(""), currentView = ref[0], setCurrentView = ref[1];
    var ref1 = (0,react.useState)(""), csvURL = ref1[0], setCsvUrl = ref1[1];
    var userPlan = (0,es/* useSelector */.v9)(userSelectors/* userSelectors.getUserPlan */.p.getUserPlan);
    var isUserUnverified = userPlan === appConfig/* userPlans.UNVERIFIED */.yG.UNVERIFIED;
    var useCaseId = router.query.useCaseId;
    var activeReport = (0,es/* useSelector */.v9)(singleUseCaseSelectors/* singleUseCaseSelectors.getActiveReport */.o.getActiveReport);
    var activeUseCase = (0,es/* useSelector */.v9)(singleUseCaseSelectors/* singleUseCaseSelectors.getActiveUseCase */.o.getActiveUseCase);
    var activeChannelsIds = (0,es/* useSelector */.v9)(singleUseCaseSelectors/* singleUseCaseSelectors.getActiveChannelsIds */.o.getActiveChannelsIds);
    var useCasesPagesDateRange = (0,es/* useSelector */.v9)(singleUseCaseSelectors/* singleUseCaseSelectors.getUseCasesPagesDateRange */.o.getUseCasesPagesDateRange);
    var activeUseCaseFetchStatus = (0,es/* useSelector */.v9)(singleUseCaseSelectors/* singleUseCaseSelectors.getActiveUseCaseFetchStatus */.o.getActiveUseCaseFetchStatus);
    var activeUseCaseError = (0,es/* useSelector */.v9)(singleUseCaseSelectors/* singleUseCaseSelectors.getActiveUseCaseError */.o.getActiveUseCaseError);
    var loading = activeUseCaseFetchStatus === "PENDING" || activeUseCaseFetchStatus === "IDLE";
    var getName = function(viewName) {
        var item = possibleUseCaseItemViews.find(function(item) {
            return item.name === viewName;
        });
        return (item === null || item === void 0 ? void 0 : item.label) || "Demyst | Use Case";
    };
    (0,react.useEffect)(function() {
        dispatch(userSlice/* userActions.setLastLoggedOutPage */.hI.setLastLoggedOutPage({
            lastLoggedOutPage: window.location.pathname
        }));
        var scrollableWindow = document.getElementsByClassName("UseCasePage__contentWrapper");
        if (scrollableWindow !== null && typeof scrollableWindow !== "undefined" && scrollableWindow.length !== 0) scrollableWindow[0].scrollTop = 0;
        var view = window.location.pathname.split("/").reverse()[0];
        setCurrentView(view);
    }, [
        router.pathname
    ]);
    (0,react.useLayoutEffect)(function() {
        dispatch(singleUseCaseSlice/* useCasesActions.setActiveUseCaseId */.BD.setActiveUseCaseId({
            useCaseId: useCaseId
        }));
    }, [
        dispatch,
        useCaseId
    ]);
    (0,react.useLayoutEffect)(function() {
        var fetch = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return dispatch(singleUseCaseSlice/* useCasesThunks.fetchSingleUseCase */.bY.fetchSingleUseCase({
                                useCaseId: useCaseId
                            }));
                        case 2:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        if (useCaseId && !activeUseCase) {
            fetch();
        }
        if (activeUseCase) {
            if (router.query["channel_id"]) {
                dispatch(singleUseCaseSlice/* useCasesActions.setActiveChannelsIds */.BD.setActiveChannelsIds({
                    channelsIds: (0,helpers/* toArray */.qo)(router.query["channel_id"])
                }));
            } else {
                // if not, dispatch action with empty payload - this will set use case's default channel
                // as active. For more info look into `setActiveChannelsIds` reducer code.
                dispatch(singleUseCaseSlice/* useCasesActions.setActiveChannelsIds */.BD.setActiveChannelsIds({}));
            }
            // the same logic as for channel id here
            if (router.query["start_date"] || router.query["end_date"]) {
                dispatch(singleUseCaseSlice/* useCasesActions.setDateRange */.BD.setDateRange({
                    startDate: router.query["start_date"],
                    endDate: router.query["end_date"]
                }));
            }
        }
    }, [
        dispatch,
        useCaseId,
        activeUseCase
    ]);
    (0,react.useEffect)(function() {
        if (activeChannelsIds.length >= 1) {
            router.query["channel_id"] = activeChannelsIds;
            router.query["start_date"] = useCasesPagesDateRange[0];
            router.query["end_date"] = useCasesPagesDateRange[1];
            router.replace({
                query: router.query
            });
        }
    }, [
        activeChannelsIds,
        useCasesPagesDateRange
    ]);
    (0,react.useEffect)(function() {
        var fetchTransactionData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, transactionsRawData, transactionsPerDayData, ref1, averageResponseTimeRawData, averageResponseTimePerDayData, ref2, errorsRawData, errorsPerDayData, csvData, csv, csvFile;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(activeReport.type === "CUMULATIVE" && getName(currentView) === "Reports")) {
                                _ctx.next = 20;
                                break;
                            }
                            _ctx.next = 3;
                            return operationalDashboardApi/* operationalDashboardApi.getQueryData */.w.getQueryData({
                                startDate: useCasesPagesDateRange[0],
                                endDate: useCasesPagesDateRange[1],
                                queryType: useCases_helpers/* useCaseQueryTypesConstants.transactions */.cL.transactions,
                                channelsIds: activeChannelsIds
                            });
                        case 3:
                            ref = _ctx.sent;
                            transactionsRawData = ref.data;
                            transactionsPerDayData = (0,useCases_helpers/* formatTransactionsData */.wv)({
                                transactionsRawData: transactionsRawData,
                                activeChannelsIds: activeChannelsIds,
                                startDate: useCasesPagesDateRange[0],
                                endDate: useCasesPagesDateRange[1]
                            }).transactionsPerDayData;
                            _ctx.next = 8;
                            return operationalDashboardApi/* operationalDashboardApi.getQueryData */.w.getQueryData({
                                startDate: useCasesPagesDateRange[0],
                                endDate: useCasesPagesDateRange[1],
                                queryType: useCases_helpers/* useCaseQueryTypesConstants.averageResponseTime */.cL.averageResponseTime,
                                channelsIds: activeChannelsIds
                            });
                        case 8:
                            ref1 = _ctx.sent;
                            averageResponseTimeRawData = ref1.data;
                            averageResponseTimePerDayData = (0,useCases_helpers/* formatAverageResponseTimeData */.rV)({
                                averageResponseTimeRawData: averageResponseTimeRawData,
                                activeChannelsIds: activeChannelsIds,
                                startDate: useCasesPagesDateRange[0],
                                endDate: useCasesPagesDateRange[1]
                            }).averageResponseTimePerDayData;
                            _ctx.next = 13;
                            return operationalDashboardApi/* operationalDashboardApi.getQueryData */.w.getQueryData({
                                startDate: useCasesPagesDateRange[0],
                                endDate: useCasesPagesDateRange[1],
                                queryType: useCases_helpers/* useCaseQueryTypesConstants.errors */.cL.errors,
                                channelsIds: activeChannelsIds
                            });
                        case 13:
                            ref2 = _ctx.sent;
                            errorsRawData = ref2.data;
                            errorsPerDayData = (0,useCases_helpers/* formatErrorsData */.u6)({
                                errorsRawData: errorsRawData,
                                activeChannelsIds: activeChannelsIds,
                                startDate: useCasesPagesDateRange[0],
                                endDate: useCasesPagesDateRange[1]
                            }).errorsPerDayData;
                            csvData = transactionsPerDayData.map(function(transaction) {
                                return (0,_object_spread/* default */.Z)({}, transaction, transaction.channelsData[activeChannelsIds[0]], errorsPerDayData.find(function(error) {
                                    return error.date === transaction.date;
                                }).channelsData[activeChannelsIds[0]], averageResponseTimePerDayData.find(function(response) {
                                    return response.date === transaction.date;
                                }).channelsData[activeChannelsIds[0]]);
                            });
                            csv = papaparse_min_default().unparse(csvData, {
                                columns: [
                                    "date",
                                    "channelId",
                                    "sampleTransactionCount",
                                    "liveTransactionCount",
                                    "hitCount",
                                    "mode",
                                    "errorCount",
                                    "averageResponseTime",
                                    "p99ResponseTime",
                                    "p95ResponseTime", 
                                ]
                            });
                            csvFile = (0,utils_csv/* createCSVBlob */.DA)(csv);
                            setCsvUrl((0,utils_csv/* getBlobUrl */.DK)(csvFile));
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchTransactionData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchTransactionData();
    }, [
        router.query,
        activeChannelsIds,
        useCasesPagesDateRange
    ]);
    var onDownloadClick = function() {
        notify/* notify.success */.h.success("Your download has started!");
        (0,userTracking/* sendGaEvent */.k8)({
            action: "CSV Download",
            category: "Platform - KPI Event",
            label: "Download CSV - Channel ".concat(activeChannelsIds[0], " (").concat(useCasesPagesDateRange[0], " to ").concat(useCasesPagesDateRange[1], ")")
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "UseCasePage",
        children: [
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "UseCasePage__loading",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {})
            }) : activeUseCaseError ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "UseCasePage__error",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlatformHead/* PlatformHead */.$, {
                        title: "An Error Occurred"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageBox/* MessageBox */._, {
                        children: activeUseCaseError.message
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* LinkButton */.Q, {
                        href: linksConstants/* linksConstants.ALL_USE_CASES */.s.ALL_USE_CASES,
                        children: "Back to Dashboard"
                    })
                ]
            }) : !(activeUseCase === null || activeUseCase === void 0 ? void 0 : activeUseCase.channels) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "UseCasePage__noData",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlatformHead/* PlatformHead */.$, {
                        title: "Use Case Not Found"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: "Use case with this ID does not exist or has no channels assigned to it."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton/* LinkButton */.Q, {
                        href: linksConstants/* linksConstants.ALL_USE_CASES */.s.ALL_USE_CASES,
                        children: "Back to Dashboard"
                    })
                ]
            }),
            !loading && activeUseCase && /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "UseCasePage__contentWrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PlatformHead/* PlatformHead */.$, {
                        title: "".concat(getName(currentView), " | ").concat(activeUseCase === null || activeUseCase === void 0 ? void 0 : activeUseCase.name)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UseCasePageHeader, {
                        activeUseCase: activeUseCase,
                        activeChannelsIds: activeChannelsIds,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: "UseCasePage__header",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeVisibility, {
                                    useCase: activeUseCase
                                }),
                                activeReport.type === "CUMULATIVE" && getName(currentView) === "Reports" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkButton/* LinkButton */.Q, {
                                    isExternal: true,
                                    href: csvURL,
                                    download: true,
                                    variant: "whiteWithShadow",
                                    onClick: onDownloadClick,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiDownload */._hL, {}),
                                        "Export"
                                    ]
                                }),
                                (activeUseCase === null || activeUseCase === void 0 ? void 0 : activeUseCase.channels.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelSwitcher, {}),
                                (getName(currentView) === "Error Logs" || getName(currentView) === "Reports" || getName(currentView) === "Alerts") && /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleUseCaseDateRangePicker, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "UseCasePage__tabs",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs/* default */.Z, {
                            variant: "line",
                            children: possibleUseCaseItemViews.filter(function(item) {
                                return !item.hidden || !item.hidden({
                                    activeUseCase: activeUseCase
                                });
                            }).map(function(view) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/app/use-cases/".concat(useCaseId, "/").concat(view.name),
                                    legacyBehavior: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_item/* default */.Z, {
                                        badgeColor: "blue",
                                        className: "UseCasePage__tabs__item ".concat(currentView === view.name ? "active" : ""),
                                        children: view.label
                                    })
                                }, view.name);
                            })
                        })
                    }),
                    isUserUnverified && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "UseCasePage__unverified__container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "UseCasePage__unverified",
                            children: [
                                "Your organization is ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Unverified"
                                }),
                                " therefore this Data API can only return sample data."
                            ]
                        })
                    }),
                    children
                ]
            })
        ]
    });
};


/***/ }),

/***/ 87751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ productsCatalogSelectors; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68697);

var getProductsFetchStatus = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.productsCatalog.products.fetchStatus;
}, function(fetchStatus) {
    return fetchStatus;
});
var getProductsError = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.productsCatalog.products.error;
}, function(error) {
    return error;
});
var getProductsEntities = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.productsCatalog.products.data.entities;
}, function(entities) {
    return entities;
});
var getProductsIds = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.productsCatalog.products.data.ids;
}, function(ids) {
    return ids;
});
var getProductsList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)([
    getProductsIds,
    getProductsEntities
], function(productsIds, productsEntities) {
    return productsIds.map(function(id) {
        if (productsEntities[id]) {
            return productsEntities[id];
        }
    });
});
var getSearchParams = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)([
    function(state) {
        return state.productsCatalog.products.searchParams;
    },
    function(state, paramName) {
        return paramName;
    }
], function(searchParams, paramName) {
    if (paramName) {
        return searchParams[paramName];
    } else {
        return searchParams;
    }
});
var getPagination = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)([
    function(state) {
        return state.productsCatalog.products.searchParams.page;
    },
    function(state) {
        return state.productsCatalog.products.totalPages;
    },
    function(state) {
        return state.productsCatalog.products.totalEntries;
    }, 
], function(currentPage, totalPages, totalEntries) {
    return {
        currentPage: currentPage,
        totalPages: totalPages,
        totalEntries: totalEntries
    };
});
var getShowFilters = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.productsCatalog.showFilters;
}, function(showFilters) {
    return showFilters;
});
var getTags = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.productsCatalog.tags;
}, function(tags) {
    return tags;
});
var getTagIds = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.productsCatalog.tagIds;
}, function(tagIds) {
    return tagIds;
});
var productsCatalogSelectors = {
    getProductsFetchStatus: getProductsFetchStatus,
    getProductsError: getProductsError,
    getProductsEntities: getProductsEntities,
    getProductsIds: getProductsIds,
    getProductsList: getProductsList,
    getSearchParams: getSearchParams,
    getPagination: getPagination,
    getShowFilters: getShowFilters,
    getTags: getTags,
    getTagIds: getTagIds
};


/***/ }),

/***/ 23750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ singleUseCaseSelectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var lodash_sortby__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58254);
/* harmony import */ var lodash_sortby__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_sortby__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3151);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44744);
/* harmony import */ var re_reselect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75879);
/* harmony import */ var re_reselect__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(re_reselect__WEBPACK_IMPORTED_MODULE_4__);






// --- USE CASES
var getUseCasesEntities = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)([
    function(state) {
        return state.singleUseCase.useCases.entities;
    }
], function(entities) {
    return entities;
});
var getUseCasesIds = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)([
    function(state) {
        return state.singleUseCase.useCases.demoUseCasesIds;
    },
    function(state) {
        return state.singleUseCase.useCases.liveUseCasesIds;
    },
    function(state, type) {
        return type;
    }, 
], function(demoIds, liveIds, type) {
    if (type) {
        switch(type){
            case "demo":
                {
                    return demoIds;
                }
            case "live":
                {
                    return liveIds;
                }
        }
    }
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(demoIds).concat([
        liveIds
    ]);
});
var getUseCasesList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)([
    function(state) {
        return state.singleUseCase.useCases;
    }
], function(useCases) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(useCases.demoUseCasesIds).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(useCases.liveUseCasesIds)).map(function(id) {
        if (useCases.entities[id]) {
            return useCases.entities[id];
        }
    });
});
var getUseCaseById = re_reselect__WEBPACK_IMPORTED_MODULE_4___default()([
    getUseCasesEntities,
    function(state, useCaseId) {
        return useCaseId;
    }
], function(useCases, useCaseId) {
    return useCases[useCaseId];
})(function(useCases, useCaseId) {
    return useCaseId;
});
var getUseCaseDefaultChannel = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)(getUseCaseById, function(useCase) {
    if (useCase) {
        var ref;
        return (ref = (0,_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getSortedChannels */ .L6)(useCase.channels)) === null || ref === void 0 ? void 0 : ref[0];
    }
});
var getDefaultChannelQueriesData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)(getUseCaseById, function(useCase) {
    return useCase === null || useCase === void 0 ? void 0 : useCase.defaultChannelQueriesData;
});
var shouldUpdateDefaultChannelQueriesData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)(getUseCaseById, function(useCase) {
    if (!(useCase === null || useCase === void 0 ? void 0 : useCase.defaultChannelQueriesDataCacheTimestamp)) return true;
    return !(0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(new Date(useCase.defaultChannelQueriesDataCacheTimestamp), new Date());
});
var getDefaultChannelQueriesDataProvidersLogos = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)(getUseCaseById, function(useCase) {
    return useCase.defaultChannelQueriesDataProvidersLogos;
});
var getUseCasesPagesDateRange = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)([
    function(state) {
        return state.singleUseCase.startDate;
    },
    function(state) {
        return state.singleUseCase.endDate;
    }
], function(startDate, endDate) {
    return [
        startDate,
        endDate
    ];
});
// --- ACTIVE USE CASE
var getActiveUseCase = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)([
    getUseCasesEntities,
    function(state) {
        return state.singleUseCase.activeUseCase.id;
    }
], function(useCases, activeUseCaseId) {
    return useCases[activeUseCaseId];
});
var getActiveUseCaseFetchStatus = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)(function(state) {
    return state.singleUseCase.activeUseCase.fetchStatus;
}, function(fetchStatus) {
    return fetchStatus;
});
var getActiveUseCaseError = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)(function(state) {
    return state.singleUseCase.activeUseCase.error;
}, function(error) {
    return error;
});
var getActiveUseCaseChannels = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)([
    getActiveUseCase
], function(activeUseCase) {
    return lodash_sortby__WEBPACK_IMPORTED_MODULE_0___default()(activeUseCase === null || activeUseCase === void 0 ? void 0 : activeUseCase.channels, "position");
});
var getActiveChannelsIds = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)(function(state) {
    return state.singleUseCase.activeUseCase.activeChannelsIds;
}, function(activeChannelsIds) {
    return activeChannelsIds;
});
var getActiveChannel = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)([
    getActiveUseCaseChannels,
    getActiveChannelsIds
], function(channels, channelsIds) {
    return channels.find(function(channel) {
        return channel.id === Number(channelsIds[0]);
    });
});
var allChannelsSelected = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)([
    getActiveUseCaseChannels,
    getActiveChannelsIds
], function(channels, activeChannelsIds) {
    // TODO: Might need some better logic for checking this
    return (channels === null || channels === void 0 ? void 0 : channels.length) === (activeChannelsIds === null || activeChannelsIds === void 0 ? void 0 : activeChannelsIds.length);
});
var getActiveUseCaseMinDate = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)([
    getActiveUseCase
], function(useCase) {
    return useCase === null || useCase === void 0 ? void 0 : useCase.date_implemented;
});
var isAnyChannelConfigurable = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)(getActiveUseCaseChannels, function(channels) {
    if (channels) {
        return channels.some(function(channel) {
            return Boolean(channel.configuration);
        });
    } else {
        return false;
    }
});
var isAnyChannelLookupable = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)(getActiveUseCaseChannels, function(channels) {
    if (channels) {
        return channels.some(function(channel) {
            return Boolean(channel.single_lookupable);
        });
    } else {
        return false;
    }
});
// --- REPORTS
var getActiveReport = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)([
    getActiveChannel,
    function(state) {
        return state.singleUseCase.reports.activeReportId;
    },
    function(state) {
        return Object.values(state.singleUseCase.dataProducts.providers.entities);
    }, 
], function(activeChannel, activeReportId, dataProducts) {
    var cumulativeReport = {
        type: "CUMULATIVE",
        id: "cumulative",
        name: "Cumulative Report"
    };
    if (activeReportId === "cumulative") {
        return cumulativeReport;
    } else {
        var provider = activeChannel.table_providers.find(function(provider) {
            return String(provider.id) === String(activeReportId);
        });
        var product = dataProducts.find(function(product) {
            return String(product.id) === String(activeReportId);
        });
        if (provider) {
            var ref;
            return {
                type: "PROVIDER",
                id: provider.id,
                name: provider.name,
                dataSourceName: (ref = provider.data_source) === null || ref === void 0 ? void 0 : ref.name,
                logo: provider.logo
            };
        } else if (product) {
            var ref1;
            return {
                type: "PROVIDER",
                id: product.id,
                name: product.name,
                dataSourceName: (ref1 = product.data_source) === null || ref1 === void 0 ? void 0 : ref1.name,
                logo: product.logo
            };
        } else {
            return cumulativeReport;
        }
    }
});
// --- DATA PRODUCTS
var getDataProductsFetchStatus = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)(function(state) {
    return state.singleUseCase.dataProducts.fetchStatus;
}, function(fetchStatus) {
    return fetchStatus;
});
var getDataProductsError = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)(function(state) {
    return state.singleUseCase.dataProducts.error;
}, function(error) {
    return error;
});
var getProvidersEntities = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)(function(state) {
    return state.singleUseCase.dataProducts.providers.entities;
}, function(providersEntities) {
    return providersEntities;
});
var getProvidersNames = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)(function(state) {
    return state.singleUseCase.dataProducts.providers.names;
}, function(providersNames) {
    return providersNames;
});
var getProvidersList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)([
    getProvidersEntities,
    getProvidersNames
], function(entities, names) {
    return names.map(function(name) {
        if (entities[name]) {
            return entities[name];
        }
    });
});
var getActiveProvidersEntitiesList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)([
    getProvidersList,
    function(state) {
        return state.singleUseCase.reports.activeReportId;
    }
], function(providers, activeReportId) {
    return providers.filter(function(provider) {
        return provider.id === activeReportId;
    });
});
var getActiveProvider = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)([
    getActiveProvidersEntitiesList
], function(activeProviders) {
    return activeProviders[0];
});
var getDataProductsMetricData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)([
    function(state) {
        return state.singleUseCase.dataProducts.metrics;
    },
    function(state, metric) {
        return metric;
    }
], function(metrics, metricType) {
    return metrics[metricType];
});
// --- TRANSACTION PANEL
var isConfigurationEdited = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)(function(state) {
    return state.singleUseCase.transactionPanel.configuration.isEdited;
}, function(isEdited) {
    return isEdited;
});
var getOverlayInfo = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__.createSelector)([
    function(state) {
        return state.singleUseCase.transactionPanel.overlay.show;
    },
    function(state) {
        return state.singleUseCase.transactionPanel.overlay.message;
    }, 
], function(showOverlay, overlayMessage) {
    return {
        showOverlay: showOverlay,
        overlayMessage: overlayMessage
    };
});
var singleUseCaseSelectors = {
    // --- USE CASES
    getUseCasesEntities: getUseCasesEntities,
    getUseCasesIds: getUseCasesIds,
    getUseCasesList: getUseCasesList,
    getUseCaseById: getUseCaseById,
    getUseCaseDefaultChannel: getUseCaseDefaultChannel,
    getDefaultChannelQueriesData: getDefaultChannelQueriesData,
    shouldUpdateDefaultChannelQueriesData: shouldUpdateDefaultChannelQueriesData,
    getDefaultChannelQueriesDataProvidersLogos: getDefaultChannelQueriesDataProvidersLogos,
    getUseCasesPagesDateRange: getUseCasesPagesDateRange,
    // --- ACTIVE USE CASE
    getActiveUseCase: getActiveUseCase,
    getActiveUseCaseFetchStatus: getActiveUseCaseFetchStatus,
    getActiveUseCaseError: getActiveUseCaseError,
    getActiveUseCaseChannels: getActiveUseCaseChannels,
    getActiveChannelsIds: getActiveChannelsIds,
    allChannelsSelected: allChannelsSelected,
    getActiveUseCaseMinDate: getActiveUseCaseMinDate,
    getActiveChannel: getActiveChannel,
    isAnyChannelConfigurable: isAnyChannelConfigurable,
    isAnyChannelLookupable: isAnyChannelLookupable,
    // --- REPORTS
    getActiveReport: getActiveReport,
    // --- DATA PRODUCTS
    getDataProductsFetchStatus: getDataProductsFetchStatus,
    getDataProductsError: getDataProductsError,
    getProvidersList: getProvidersList,
    getActiveProvidersEntitiesList: getActiveProvidersEntitiesList,
    getActiveProvider: getActiveProvider,
    getDataProductsMetricData: getDataProductsMetricData,
    // --- TRANSACTION PANEL
    isConfigurationEdited: isConfigurationEdited,
    getOverlayInfo: getOverlayInfo
};


/***/ }),

/***/ 74918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ userSelectors; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68697);

var isUserLoggedIn = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.isUserLoggedIn;
}, function(isUserLoggedIn) {
    return isUserLoggedIn;
});
var getUserData = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.userData;
}, function(userData) {
    return userData;
});
var getUserPermissions = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    var ref, ref1;
    return (ref = state.user.userData) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.permissions;
}, function(permissions) {
    return permissions;
});
var getBlackfinJWT = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.blackfinJWT;
}, function(blackfinJWT) {
    return blackfinJWT;
});
var getContactUsModalState = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.contactUsModalOpen;
}, function(contactUsModalOpen) {
    return contactUsModalOpen;
});
var isAdmin = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    var ref, ref1;
    return (ref = state.user.userData) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.permissions;
}, function(permissions) {
    return (permissions === null || permissions === void 0 ? void 0 : permissions.can_show_admin) === true;
});
var getUserPlan = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    var ref, ref1;
    return (ref = state.user.userData) === null || ref === void 0 ? void 0 : (ref1 = ref.organization) === null || ref1 === void 0 ? void 0 : ref1.formatted_plan;
}, function(formatted_plan) {
    return formatted_plan;
});
var isUserDataFetching = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.isUserDataFetching;
}, function(isUserDataFetching) {
    return isUserDataFetching;
});
var isTosOutdated = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)([
    function(state) {
        return state.user.isUserLoggedIn;
    },
    function(state) {
        return state.user.userData;
    }
], function(isUserLoggedIn, userData) {
    var ref;
    return isUserLoggedIn && (userData === null || userData === void 0 ? void 0 : (ref = userData.user) === null || ref === void 0 ? void 0 : ref.tos_outdated);
});
var hasUserBeenLoggedOutManually = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.hasBeenLoggedOutManually;
}, function(hasBeenLoggedOutManually) {
    return hasBeenLoggedOutManually;
});
var hasNewOrOneTrueCreditsEnabled = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)([
    function(state) {
        var ref, ref1;
        return (ref = state.user.userData) === null || ref === void 0 ? void 0 : (ref1 = ref.organization) === null || ref1 === void 0 ? void 0 : ref1.credits_or_caps;
    },
    function(state) {
        var ref, ref1;
        return (ref = state.user.userData) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.permissions;
    }, 
], function(creditsOrCaps, permissions) {
    return creditsOrCaps === "new_credits" || creditsOrCaps === "one_credit_to_rule_them_all" || [
        "demyst_admin",
        "demyst_admin_org_edit",
        "demyst_client"
    ].some(function(p) {
        return (permissions || {})[p];
    });
});
var lastLoggedOutPage = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.lastLoggedOutPage;
}, function(lastLoggedOutPage) {
    return lastLoggedOutPage;
});
var hasSigned = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.hasSigned;
}, function(hasSigned) {
    return hasSigned;
});
var hasProvidedBilling = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.hasProvidedBilling;
}, function(hasProvidedBilling) {
    return hasProvidedBilling;
});
var hasRequestedAgreement = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.hasRequestedAgreement;
}, function(hasRequestedAgreement) {
    return hasRequestedAgreement;
});
var hasApproval = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__.createSelector)(function(state) {
    return state.user.hasApproval;
}, function(hasApproval) {
    return hasApproval;
});
var userSelectors = {
    isAdmin: isAdmin,
    isUserLoggedIn: isUserLoggedIn,
    getUserData: getUserData,
    isUserDataFetching: isUserDataFetching,
    getUserPermissions: getUserPermissions,
    isTosOutdated: isTosOutdated,
    getBlackfinJWT: getBlackfinJWT,
    getContactUsModalState: getContactUsModalState,
    getUserPlan: getUserPlan,
    hasUserBeenLoggedOutManually: hasUserBeenLoggedOutManually,
    hasNewOrOneTrueCreditsEnabled: hasNewOrOneTrueCreditsEnabled,
    lastLoggedOutPage: lastLoggedOutPage,
    hasSigned: hasSigned,
    hasProvidedBilling: hasProvidedBilling,
    hasRequestedAgreement: hasRequestedAgreement,
    hasApproval: hasApproval
};


/***/ }),

/***/ 64357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ formAttribution; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);

var formAttribution = function(body) {
    var landingPage = localStorage.getItem("landing_page");
    var landingPageDatetime = localStorage.getItem("landing_page_datetime");
    var landingPageFullUrl = localStorage.getItem("landing_page_full_url");
    var currentPagePath = localStorage.getItem("current_page_path");
    var currentPagePathDatetime = localStorage.getItem("current_page_path_datetime");
    var prevPagePath = localStorage.getItem("prev_page_path");
    var prevPagePathDatetime = localStorage.getItem("prev_page_path_datetime");
    var pageFlow = JSON.parse(localStorage.getItem("page_flow"));
    var sessionPageFlow = JSON.parse(sessionStorage.getItem("session_page_flow"));
    var gaAdCookie = localStorage.getItem("gaAd");
    var gaAdCookieUpdated = localStorage.getItem("gaAd_updated");
    var gaAdCookieCreated = localStorage.getItem("gaAd_created");
    var isProductKickingAss = (landingPage === null || landingPage === void 0 ? void 0 : landingPage.startsWith("/external-data/")) || (landingPage === null || landingPage === void 0 ? void 0 : landingPage.startsWith("/third-party-data/"));
    var googleAdsGclid = localStorage.getItem("gclid");
    var googleAdsGclidCreated = localStorage.getItem("gclid_created");
    var googleAdsGclidUpdated = localStorage.getItem("gclid_updated");
    var linkedInCookie = localStorage.getItem("li_fat_id");
    var linkedInCookieCreated = localStorage.getItem("li_fat_id_created");
    var linkedInCookieUpdated = localStorage.getItem("li_fat_id_updated");
    var utmMedium = localStorage.getItem("utm_medium");
    var utmMediumCreated = localStorage.getItem("utm_medium_created");
    var utmMediumUpdated = localStorage.getItem("utm_medium_updated");
    var utmSource = localStorage.getItem("utm_source");
    var utmSourceCreated = localStorage.getItem("utm_source_created");
    var utmSourceUpdated = localStorage.getItem("utm_source_updated");
    var utmCampaign = localStorage.getItem("utm_campaign");
    var utmCampaignCreated = localStorage.getItem("utm_campaign_created");
    var utmCampaignUpdated = localStorage.getItem("utm_campaign_updated");
    var utmContent = localStorage.getItem("utm_content");
    var utmContentCreated = localStorage.getItem("utm_content_created");
    var utmContentUpdated = localStorage.getItem("utm_content_updated");
    var utmTerm = localStorage.getItem("utm_term");
    var utmTermCreated = localStorage.getItem("utm_term_created");
    var utmTermUpdated = localStorage.getItem("utm_term_updated");
    var marketingSource = linkedInCookie ? "linkedin" : googleAdsGclid ? "google(cpc)" : null;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        body: body
    }, landingPage && {
        landing_page: landingPage
    }, landingPageFullUrl && {
        landing_page_full_url: landingPageFullUrl
    }, landingPageDatetime && {
        landing_page_datetime: landingPageDatetime
    }, currentPagePath && {
        current_page_path: currentPagePath
    }, currentPagePathDatetime && {
        current_page_path_datetime: currentPagePathDatetime
    }, prevPagePath && {
        prev_page_path: prevPagePath
    }, prevPagePathDatetime && {
        prev_page_path_datetime: prevPagePathDatetime
    }, sessionPageFlow && {
        session_page_flow: sessionPageFlow
    }, pageFlow && {
        macro_page_flow: pageFlow
    }, utmMedium && {
        utm_medium: utmMedium
    }, utmMediumCreated && {
        utm_medium_created: utmMediumCreated
    }, utmMediumUpdated && {
        utm_medium_updated: utmMediumUpdated
    }, utmSource && {
        utm_source: utmSource
    }, utmSourceCreated && {
        utm_source_created: utmSourceCreated
    }, utmSourceUpdated && {
        utm_source_updated: utmSourceUpdated
    }, utmCampaign && {
        utm_campaign: utmCampaign
    }, utmCampaignCreated && {
        utm_campaign_created: utmCampaignCreated
    }, utmCampaignUpdated && {
        utm_campaign_updated: utmCampaignUpdated
    }, utmContent && {
        utm_content: utmContent
    }, utmContentCreated && {
        utm_content_created: utmContentCreated
    }, utmContentUpdated && {
        utm_content_updated: utmContentUpdated
    }, utmTerm && {
        utm_term: utmTerm
    }, utmTermCreated && {
        utm_term_created: utmTermCreated
    }, utmTermUpdated && {
        utm_term_updated: utmTermUpdated
    }, marketingSource && {
        marketing_source: marketingSource
    }, gaAdCookie && {
        gaAd: gaAdCookie
    }, gaAdCookieCreated && {
        gaAd_created: gaAdCookieCreated
    }, gaAdCookieUpdated && {
        gaAd_updated: gaAdCookieUpdated
    }, isProductKickingAss && {
        pikYa: isProductKickingAss
    }, googleAdsGclid && {
        gclid: googleAdsGclid
    }, googleAdsGclidCreated && {
        gclid_created: googleAdsGclidCreated
    }, googleAdsGclidUpdated && {
        gclid_updated: googleAdsGclidUpdated
    }, linkedInCookie && {
        li_fat_id: linkedInCookie
    }, linkedInCookieCreated && {
        li_fat_id_created: linkedInCookieCreated
    }, linkedInCookieUpdated && {
        li_fat_id_updated: linkedInCookieUpdated
    }, document.referrer && {
        referrer: document.referrer
    });
};


/***/ }),

/***/ 65303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ adjustTime; },
/* harmony export */   "s": function() { return /* binding */ getFormattedDateRange; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3151);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4758);
/* harmony import */ var _date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77715);



var getFormattedDateRange = function(startDate, endDate) {
    var dateFormat = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "MMM dd, yyyy";
    if (!startDate || !endDate) {
        return;
    }
    var startDateObj, endDateObj;
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(startDate, Date)) {
        startDateObj = startDate;
    } else {
        startDateObj = (0,_date__WEBPACK_IMPORTED_MODULE_1__/* .createDateFromString */ .Z)(startDate);
    }
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(endDate, Date)) {
        endDateObj = endDate;
    } else {
        endDateObj = (0,_date__WEBPACK_IMPORTED_MODULE_1__/* .createDateFromString */ .Z)(endDate);
    }
    if ((0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(startDateObj, endDateObj)) {
        return (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(startDateObj, dateFormat);
    } else {
        return "".concat((0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(startDateObj, dateFormat), " - ").concat((0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(endDateObj, dateFormat));
    }
};
var adjustTime = function(str) {
    var arr = str.split("-");
    var month = arr[1];
    var last = arr[arr.length - 1];
    var months = [
        "01",
        "03",
        "05",
        "07",
        "08",
        "10",
        "12"
    ];
    var adjustMonth = function(str) {
        var arr = str.split("-");
        arr[1] = parseInt(arr[1]) + 1;
        arr[arr.length - 1] = "01";
        if (arr[1] < 10) {
            arr[1] = "0" + arr[1];
        }
        return arr.join("-");
    };
    var adjustYear = function(str) {
        var arr = str.split("-");
        arr[0] = parseInt(arr[0]) + 1;
        arr[1] = "01";
        arr[2] = "01";
        return arr.join("-");
    };
    var adjustDay = function() {
        if (parseInt(arr[arr.length - 1]) < 9) {
            arr[arr.length - 1] = "0" + (parseInt(arr[arr.length - 1]) + 1);
        } else {
            arr[arr.length - 1] = (parseInt(arr[arr.length - 1]) + 1).toString();
        }
        return arr.join("-");
    };
    if (parseInt(last) === 31 && parseInt(month) === 12) {
        return adjustYear(str);
    }
    if (parseInt(last) === 31) {
        return adjustMonth(str);
    }
    if (months.indexOf(month) === -1 && parseInt(last) === 30) {
        return adjustMonth(str);
    }
    if (months.indexOf(month) !== -1 && parseInt(last) === 31) {
        return adjustMonth(str);
    }
    adjustDay();
    return arr.join("-");
};


/***/ }),

/***/ 94103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useAxiosSource; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);


/**
 * Hook creates Axios' source as an instance variable using `useRef` hook.
 * @returns {{cancel: (function(): void), setSource: (function(): void), getSource: (function(): React.MutableRefObject<null>), getToken: (function(): (CancelToken | undefined))}}
 */ var useAxiosSource = function() {
    var source = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var getSource = function() {
        return source.current;
    };
    var setSource = function() {
        source.current = axios__WEBPACK_IMPORTED_MODULE_1___default().CancelToken.source();
    };
    var cancel = function() {
        var ref;
        source === null || source === void 0 ? void 0 : (ref = source.current) === null || ref === void 0 ? void 0 : ref.cancel();
    };
    var getToken = function() {
        var ref;
        return source === null || source === void 0 ? void 0 : (ref = source.current) === null || ref === void 0 ? void 0 : ref.token;
    };
    return {
        getSource: getSource,
        setSource: setSource,
        cancel: cancel,
        getToken: getToken
    };
};


/***/ }),

/***/ 49591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useShowPricing; }
/* harmony export */ });
/* harmony import */ var _redux_user_userSelectors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74918);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81043);


var useShowPricing = function() {
    var isUserLoggedIn = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_user_userSelectors__WEBPACK_IMPORTED_MODULE_0__/* .userSelectors.isUserLoggedIn */ .p.isUserLoggedIn);
    var hasNewOrOneTrueCreditsEnabled = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_redux_user_userSelectors__WEBPACK_IMPORTED_MODULE_0__/* .userSelectors.hasNewOrOneTrueCreditsEnabled */ .p.hasNewOrOneTrueCreditsEnabled);
    if (!isUserLoggedIn) {
        return false;
    }
    return hasNewOrOneTrueCreditsEnabled;
};


/***/ }),

/***/ 18710:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"UnverifiedForm_form__2foxS","close":"UnverifiedForm_close__8WgE_","modal":"UnverifiedForm_modal__C4CQc","inputTitle":"UnverifiedForm_inputTitle__tLOfO","title":"UnverifiedForm_title__90eeQ","description":"UnverifiedForm_description__w5BDr","infoBox":"UnverifiedForm_infoBox__uSDAS","infoDescription":"UnverifiedForm_infoDescription__TKWEi","submitButton":"UnverifiedForm_submitButton__OqRO0","field":"UnverifiedForm_field__9ovRw","textArea":"UnverifiedForm_textArea__31h21","loading":"UnverifiedForm_loading__1gwVU","error":"UnverifiedForm_error__Dm1L2"};

/***/ })

}]);